<template>
    <div class="container"
        :class="{'deep-black': true}"
    >
        <div v-if="$route.query.dev" style="position:fixed; z-index: 99999;top: 0px;background-color: rgba(255,255,0,.3);font-size: 12px;pointer-events: none;">
            <p>observer: {{observer.length}}</p>
            <p>isOnceLoad: {{isOnceLoad}}</p>
            <p>guideStep:{{$store.state.guideStep}}</p>
            <p>operationSteps:{{$store.state.operationSteps}}</p>
            <p>saving: {{$store.state.saving}}</p>
            <p>isBuildCocos:{{$store.state.isBuildCocos}}</p>
            <p>blocksForm:{{$store.state.menusData.blocksForm.length}}</p>
            <p>blocksSelected:{{$store.state.menusData.blocksSelected}}</p>
            <p>lessonSelected:{{$store.state.menusData.lessonSelected}}</p>
            <p>willGoBlock:{{$store.state.menusData.willGoBlock}}</p>
            <p>willGo:{{$store.state.menusData.willGo}}</p>
            <p>isCocosSaving:{{isCocosSaving}}</p>
            <p>initial: {{$store.state.initial}}</p>
            <p>type: {{$store.state.menusData.lessonSelectedConfig && $store.state.menusData.lessonSelectedConfig.type}}</p>
            <p>operation: {{operation.length}}</p>
            <p>item1: {{menusDataIds[1608270420000.9172]}}</p>
            <p>item2: {{menusDataIds[1609901769000]}}</p>
        </div>
        <div v-if="!['initial','done'].includes(guideStep)" class="guide">
            <Guide />
            <types
                class="type-guide"
                v-if="['second'].includes(guideStep)"
                :class="{guideStep: ['second'].includes(guideStep)}"
                :show.sync="showType"
                :selected.sync="selectedType"
                :navId.sync="$store.state.menusData.scenes_stage_id"
                @closeBackAudio="closeBackAudio"
                @onFeedBack="onFeedBack"
            />
            <contents
                v-if="['third'].includes(guideStep)"
                type="guide"
                class="content-guide"
                :zhezhao.sync="optIsShow"
                :showType.sync="showType"
                :showMenu.sync="showMenu"
                :isPractice.sync="isPractice"
                :selectedType.sync="selectedType"
                :form-length="curForms.length"
                :class="{guideStep: ['third'].includes(guideStep)}"
                :isMenus.sync="isMenus"
                @addPage="addPage"
                @save="saveConfig"
                @insertPPT="insertPPT"
            />
        </div>
        <top
            ref="top"
            theme="deep-black"
            :class="{guideStep: ['four'].includes(guideStep)}"
            :isMenu="true"
            :defaulValue.sync="oldDetailData"
            :lesson.sync="lessonInfo"
            :isPractice.sync="isPractice"
            :isHasOneMenu.sync="isHasOneMenu"
            :practiceScene.sync="practiceScene"
            @preview="beforePreview"
            @save="save"
            @oldSave="oldSave"
            @send="atBeforeSend"
            @quit="beforeQuit"
            @flashPPT="flashPPT"
            @onPracticeScene="onPracticeScene"
        />
        <div class="content">
            <menus
                v-if="!$store.state.initial"
                ref="menus"
                :show.sync="showMenu"
                :lessonIsAdd="true"
                :menus-data.sync="$store.state.menusData"
                :mouseEnterNav.sync="newMouseEnterNav"
                :mouseEnterNavItem.sync="newMouseEnterNavItem"
                :mouseEnterItem.sync="newMouseEnterItem"
                :mouseEnterLessonList.sync="newMouseEnterLessonList"
                :isOptType.sync="isOptType"
                :isOptToBlock.sync="isOptToBlock"
                :optToBlockItem.sync="optToBlockItem"
                :curForms.sync="curForms"
                :isPractice.sync="isPractice"
                :class="{guideStep: ['first'].includes(guideStep)}"
                @onCurForm="onCurForm"
                @onAdd="onAdd"
                @onEdit="onEdit"
                @onDelete="onDelete"
                @save="saveConfig"
                @rightClick="getMouseIsRight"
                @flashContent="flashContent"
                @flushStatus="flushStatus"
                @flashPPTList="flashPPTList"
            />
            <div class="loyout-right">
                <div v-if="$store.state.is_global_select_menu" class="global-disbaled"></div>
                <contents
                        v-if="isContents"
                        ref="content"
                        :zhezhao.sync="optIsShow"
                        :showType.sync="showType"
                        :showMenu.sync="showMenu"
                        :isPractice.sync="isPractice"
                        :selectedType.sync="selectedType"
                        :form-length="curForms.length"
                        :isOnceLoad.sync="isOnceLoad"
                        @addPage="addPage"
                        @save="saveConfig"
                        @insertPPT="insertPPT"
                />
                <types
                    :show.sync="showType"
                    :selected.sync="selectedType"
                    :navId.sync="$store.state.menusData.scenes_stage_id"
                    @closeBackAudio="closeBackAudio"
                    @onFeedBack="onFeedBack"
                />
            </div>
        </div>
        <Operation
            :item.sync="optItem"
            :isShow.sync="optIsShow"
            :left.sync="x"
            :top.sync="y"
            :form.sync="optData"
            :title.sync="optDataTitle"
            @onOperation="onOperation"
        />
        <OptToBlock
            v-if="isOptToBlock"
            :type.sync="isOptType"
            :visible.sync="isOptToBlock"
            :optToBlockItem.sync="optToBlockItem"
            :menusData.sync="$store.state.menusData"
            @onCancel="onCancel"
            @addPage="autoAddPage"
            @defaultSelectMenu="defaultSelectMenu"
        />
        <FeedBack
            v-if="isFeedBack"
            :visible.sync="isFeedBack"
            :form.sync="feedForm"
        />
        <IMVoiceConfig
            v-if="isVoiceConfig"
            :visible.sync="isVoiceConfig"
            :defaultValue.sync="voiceConfig"
            @onVoiceConfig="onVoiceConfig"
        />
        <OperationFont
            v-if="isOperationFont"
            :left.sync="newLeft"
            :top.sync="newTop"
            :defaultValue.sync="oldOperationFont"
            @onOperationFont="onOperationFont"
        />
        <More
            v-if="isMore"
            :isEdit="true"
            :curEditItem.sync="curEditItem"
            :visible.sync="isMore"
            :isCocos.sync="isCocos"
            :type.sync="moreType"
            :categoryId.sync="categoryId"
            :catalog.sync="curCatalog"
            :callBack.sync="callBack"
            :isWordAudio.sync="isWordAudio"
            :selfFlag.sync="selfFlag"
        />
        <Detail
            ref="detail"
            v-if="isBeforePackat"
            :id.sync="$route.query.id"
            :practiceId.sync="$route.query.practice_id"
            :visible.sync="isBeforePackat"
            :cover.sync="lessonInfo.cover"
            :lessonInfo.sync="lessonInfo"
            :isPractice.sync="isPractice"
            @onDetail="send"
            @onUpdate="onUpdate"
        />
        <Progress
            v-if="isProgress"
            :value.sync="progressValue"
        />
        <textEdit
            :visible.sync="textVisible"
            :data.sync="textData"
            @updateTextFont="updateTextFont"
        />
        <iframe style="width: 0px;height: 0px; overflow: hidden;" src="/bridge" frameborder="0"></iframe>
        <!--<iframe id="course" :src="course_web" />-->
        <div class="notice" v-show="notice.state">
            <div class="notice_title"><i :class="notice.ico"></i>{{notice.info}}</div>
        </div>
        <div class="edit_test" v-if="isTest">
            <ul>
                <li>当前是否可键盘操作：{{$store.state.menusKeyBoard}}</li>
                <li>当前课件：{{$store.state.menusData.lessonSelected}}</li>
                <li>当前导航：{{$store.state.menusData.blocksSelected}}</li>
            </ul>
        </div>
    </div>
</template>

<script>
    import VueCookie from 'vue-cookie'
    import {mapState, mapGetters, mapActions} from 'vuex'
    import common from '../common'
    import top from './components/top'//编辑器顶部栏目
    import menus from './components/menus'//编辑器菜单
    import contents from './components/contents'
    import types from './components/types'
    import Operation from '../../components/Operation'
    import OptToBlock from '../../components/OptToBlock'
    import OperationFont from './components/operationFont'
    import LocalStorage from '../../utils/localStorageUtil'
    import More from './components/types/components/more'
    import Detail from './components/detail'
    import Progress from './components/progress'
    import Guide from './components/guide'
    import textEdit from './components/textEdit'
    // import * as MenusApi from '../../api/menusApi'
    import { AudioPause, AudioDestory } from "../../utils/audio";
    import {
        getMouseLeft,
        getMouseRight,
        getMessage
    } from "../../utils/messageEvent";
    import {isNull,getRandomByObj} from "../../utils/utils";
    import * as lessonOper from "../../utils/lessonUtil";
    import { authCookie } from "../../utils/enums";

    import * as commonServer from '../../api/common'
    import * as resultServer from '../../api/result'
    import * as localData from '../../api/localdata'
    import * as GlobalServer from '../../api/global'
    import * as LoginServer from '../../api/login'
    import Config from '../../config/app'

    const IsHasOneMenu = '您未创建课件导航'

    export default {
        name: "mainTheme",
        mixins: [common],
        components: {
            top,
            menus,
            contents,
            types,
            Operation,
            OptToBlock,
            OperationFont,
            More,
            Detail,
            Progress,
            Guide,
            textEdit,
        },
        computed:{
            ...mapState([
                'token',
                'isCocosSaving',
                'editGameConfig',
                'menusDataIds',
                'mulSelect',
                'guideStep'
            ]),
            ...mapGetters(['allow2CocosKeboard']),
            // 判断当前是否存在至少一个菜单目录
            isHasOneMenu(){
                let state = false
                try {
                    if(this.$store.state.menusData.blocksForm.length) state = true
                } catch (e) {
                    console.log('判断至少一个菜单目录失败', e)
                }
                return state
            },
            // 判断是否是游戏练习
            isPractice(){
                return `${this.$route.query.is_practice}` === 'true'
            },
            // 判断是否有游戏练习id
            isPracticeId(){
                return !!this.$route.query.practice_id
            },
            key(){
                const id = this.$route.query.id
                const userInfo = this.$store.state.userInfo ? this.$store.state.userInfo : {...this.$store.state.userInfoTwo, ...this.$store.state.userInfoTwo.as_agent}
                return `${userInfo.id}_${this.source}_${id}`
            },
            source(){
                // source 1 我的课件 2 我的模板 3 公共模板
                let newSource = 1
                if(`${this.$route.query.is_template}` === 'true'){
                    newSource = 2
                    if(`${this.$route.query.is_shop}` === 'true') newSource = 3
                }
                return newSource
            },
            // 编辑导航
            nav_manage_edit(){
                return true // this.$store.state.menusData.scenes_state_shop?this.$store.state.permissions['nav_manage_shop_edit']:this.$store.state.permissions['nav_manage_my_edit']
            },
            isTemplate(){
                return `${this.$route.query.is_template}` === 'true'
            },
            isShop(){
                return `${this.$route.query.is_shop}` === 'true'
            },
            addResource(){
                return this.isShop?'addResourceShop':'addResource'
            },
            updateResource(){
                return this.isShop?'updateResourceShop':'updateResource'
            },
            getResourceDetail(){
                return this.isShop?'getResourceShopDetail':'getResourceDetail'
            },
            getResourceList(){
                return this.isShop?'getResourceListShop':'getResourceList'
            }
        },
        watch: {
            '$store.state.notice': {
                handler(vl){
                    this.notice=vl
                },
                deep: true,
            },
            '$store.state.isBuildCocos': {
                handler(vl){
                    if(vl){
                        this.buildCocosFn = setTimeout(()=>{
                            this.$store.dispatch('setSaving', false)
                        }, 10000)
                    } else {
                        clearTimeout(this.buildCocosFn)
                    }
                },
                deep: true
            },
            '$store.state.curForms':{
                handler(vl){
                    console.log('$store.state.curForms',$store.state.curForms);
                    this.$refs.menus && this.$refs.menus.handleNodeClick({
                        data: {
                            unique: this.$store.state.menusData.blocksSelected,
                            children: vl
                        }
                    })
                }
            },
            '$route.query.id': {
                handler(vl){
                    if(vl && this.isInitalNav){
                        this.isInitalNav = false

                        this.excFnAddPage()
                    }
                },
                immediate: true
            },
            '$route.query.practice_id': {
                handler(vl){
                    if(vl && this.isInitalNav){
                        this.isInitalNav = false

                        this.excFnAddPage()
                    }
                },
                immediate: true
            },
            practiceScene:{
                handler(vl) {
                    if (typeof vl === 'string' && vl.length > 1) {
                        try {
                            this.practiceScene = JSON.parse(vl)
                        } catch (e) {
                            console.log('转换失败==>', e)
                        }
                    }
                },
                deep: true,
                immediate: true
            },
            // '$route.query.id':{
            //     handler(){
            //         this.socketHeatBeat()
            //     },
            //     deep: true,
            //     immediate: true
            // },
            showMenu(state){
                if(state){
                    this.newLeft = this.newLeft + 140
                }else{
                    this.newLeft = this.newLeft - 140
                }
            },
            showType(state){
                if(state){
                    this.newLeft = this.newLeft - 140
                }else{
                    this.newLeft = this.newLeft + 140
                    AudioPause()
                }
            },
            isMore(state) {
                if(state){
                    this.setSendKeyBoardToCocos({key: 'isMore', value: false})
                }else{
                    this.setSendKeyBoardToCocos({key: 'isMore', value: true})
                }
                if (!state) AudioPause()
            },
            optIsShow(state) {
                if(state){
                    this.setSendKeyBoardToCocos({key: 'optIsShow', value: false})
                }else{
                    this.setSendKeyBoardToCocos({key: 'optIsShow', value: true})
                }
            },
            isOptToBlock(state) {
                if(state){
                    this.setSendKeyBoardToCocos({key: 'isOptToBlock', value: false})
                }else{
                    this.setSendKeyBoardToCocos({key: 'isOptToBlock', value: true})
                }
            },
            isVoiceConfig(state) {
                if(state){
                    this.setSendKeyBoardToCocos({key: 'isVoiceConfig', value: false})
                }else{
                    this.setSendKeyBoardToCocos({key: 'isVoiceConfig', value: true})
                }
            },
            isBeforePackat(state) {
                if(state){
                    this.setSendKeyBoardToCocos({key: 'isBeforePackat', value: false})
                }else{
                    this.setSendKeyBoardToCocos({key: 'isBeforePackat', value: true})
                }
            },
            isProgress(state) {
                if(state){
                    this.setSendKeyBoardToCocos({key: 'isProgress', value: false})
                }else{
                    this.setSendKeyBoardToCocos({key: 'isProgress', value: true})
                }
            },
            '$store.state.menusData':{
                handler(vl, oldValue){
                    console.log('$store.state.menusData', vl)
                    if(JSON.stringify(vl) === JSON.stringify(oldValue)) return false
                    if(!this.initial) {
                        if (vl) this.$store.state.menusData = vl

                        if (vl.blocksForm && vl.blocksForm.length > 0 && this.isHasData(vl.blocksForm)) {
                            this.saveConfig(true)
                        }
                    }
                    if (this.initial) {
                        this.initial = false
                    }
                    // this.logRemark = this.$utils.getObjByCurLesson({data: vl.blocksForm, unique: '0.9931895367958783'})
                },
                deep: true,
                immediate: true
            },
            // 菜单选中更新
            '$store.state.menusData.blocksSelected':{
                handler(vl, old){
                    console.warn('this.$store.state.menusData',this.$store.state.menusData)
                    if(
                        this.isCocosSaving ||
                        this.$store.state.initial
                    ) return false
                    // const {id, practice_id} = this.$route.query
                    // if(!id && !practice_id) return false
                    if(!vl && this.menusData.blocksForm && this.menusData.blocksForm.length){
                        console.log("菜单选中更新菜单选中更新菜单选中更新",old);
                        this.$store.state.menusData.blocksSelected = old
                        const operation = [{node: 'root', key:'blocksSelected', data: old, operation: 'value'}]
                        $eventBus.$emit('__save__',true,null, operation)
                    } else {
                        console.log('blocksSelected==>', vl)
                        console.warn('优化速度==>blocksSelected')
                        // TODO 菜单选中更新
                        const operation = [{node: 'root', key: 'blocksSelected', data: vl, operation: 'value'}]
                        $eventBus.$emit('__save__', true, null, operation)
                        console.log('操作==>菜单选中更新', operation)
                    }
                    $eventBus.$emit('onFlashLesson')
                },
                deep: true,
                immediate: true
            },
            // 如果菜单被切换，默认关闭文字弹窗
            '$store.state.menusData.lessonSelected':{
                handler(vl){
                    if(
                        this.isCocosSaving ||
                        this.$store.state.initial
                    ) return false
                    const {id, practice_id} = this.$route.query
                    if(!id && !practice_id) return false
                    //console.warn('优化速度==>lessonSelected')
                    // TODO 课件选中更新
                    const operation = [
                        {node: 'root', key:'lessonSelected', data: vl, operation: 'value'},
                        {node: 'root', key:'lessonSelectedConfig', data: this.$store.state.menusData.lessonSelectedConfig||{}, operation: 'value'}
                    ]
                    $eventBus.$emit('__save__',true,null, operation)
                    console.log('操作==>课件选中更新', operation)

                    if(this.isOperationFont) this.isOperationFont = false
                },
                deep: true,
                immediate: true
            },
            // 如果菜单被切换，默认关闭文字弹窗
            // '$store.state.menusData.blocksForm':{
            //     handler(vl){
            //         let newValue = this.$utils.getNewMenusData(vl)
            //         if (newValue && newValue[0] && typeof newValue[0].name ==='object') this.$store.state.menusData.blocksForm = newValue
            //     },
            //     deep: true,
            //     immediate: true
            // },
            menusData:{
                handler(vl){
                    this.$store.dispatch('setMenusData', vl)
                },
                deep: true,
                immediate: true
            },
            // newMenusData: {
            //     handler(vl){
            //         console.log('更新数据==>', vl)
            //         if(vl){
            //             this.$store.state.menusData.blocksForm = vl
            //         }
            //     },
            //     deep: true,
            //     immediate: true
            // }
        },
        // beforeCreate () {
        //     // 创建之前先判断token存在否，如果不存在调转到中间授权
        //     const path = this.$route.fullPath
        //     if (path.indexOf('token=') > -1) {
        //         const tokenData = path.split('token=')[1]
        //         LocalStorage.setToken(tokenData)
        //     }
        //
        //     // 设置初始化配置
        //     if(this.$route.query && Object.keys(this.$route.query).length>0) {
        //         this.$store.dispatch('setInitConfig', {
        //             school_id: this.$route.query.school_id,
        //             ...this.$route.query
        //         })
        //     } 
        // },
        async created() {
            if(Config.isTest)console.log("当前版本：20210923");
            let auth=this.$route.query.auth;
            let getClient=this.$route.query.access_client;
            if(!isNull(auth) && !isNull(getClient)){
                this.$store.state.token = auth
                this.$cookie.set(authCookie.token, auth, { expires: 30, domain: Config.domain })
                this.$cookie.set(authCookie.client_id, getClient, { expires: 30, domain: Config.domain })
                this.heartRun=false;
                //console.log("有新的参数进入，重新设置cookie22",this.$cookie.get(authCookie.token),this.$cookie.get(authCookie.client_id));
                //console.log("authCookie   Config",authCookie,Config);
                //console.log("this.$store.state.token",this.$store.state.token);
            }
            this.heartStr=this.$cookie.get("heartStart");
            if(this.heartRun)this.getHeart();
            let isTopWindow=window.self === window.top;
            console.log("当前是否为顶级窗口：",isTopWindow);
            
            this.$store.state.guideStep = 'initial'
            // 监听cocos侧发过来的通知
            this.messageEvent()

            // 设置权限
            if (Object.keys(this.$store.state.permissions).length === 0) {
                let data2 = null
                let data = null
                const newObj = {}
                if(`${this.$route.query.school_id}` === '-1' || `${this.$store.state.initConfig.school_id}` === '-1'){
                    data2 = await LoginServer.getUserInfo()
                    data2.admin_permissions.forEach(v => {
                        newObj[v] = true
                    })
                } else if(`${this.$route.query.school_id}` === '0' || `${this.$store.state.initConfig.school_id}` === '0'){
                    data2 = await GlobalServer.getPermissionsByUser()
                    data = data2.platform.role_permission.code_personal
                } else {
                    let http = 'https'
                    if (Config.isDev) {
                        http = 'http'
                    }
                    data2 = await GlobalServer.getSchool()
                    this.$store.state.school = data2.school

                    const domain = this.$store.getters.getShoolConfig.domain
                    if (domain && domain.length>3) {
                        // this.$store.dispatch('initPermissions')
                        if(Config.isTest)console.log('domain==>1', domain)
                        data = await GlobalServer.getPermissions({
                            url: http + '://' + domain + '/api/user'
                        })
                        data = data.school_role_permission_ids
                    }
                }
                data && data.route_names.map(v => {
                    if ((`${v}`.indexOf('management_courseware') > -1) && v.slice(22)) {
                        newObj[v.slice(22)] = true
                    }
                })
                this.$store.state.permissions = newObj
            }

            // 全局监听保存事件
            $eventBus.$on('__save__',this.observerPrettify)
            $eventBus.$on('onCurForm',this.onCurForm)
            $eventBus.$on('changeMenuItem',this.changeMenuItem)

            // 模拟cocos发送消息
            window.cocosSetFont = ()=>this.$toCocosMessage({type: 'SetFont', value: {isShow: true, left: 50, top: 50, config: {b:true}}})
            window.webGoTokejian = this.webGoTokejian

            this.$nextTick(()=>{
                this.getUserInfoDetail()
                getMouseLeft(this.getMouseIsLeft)
                getMouseRight(this.getMouseIsRight)
                setImmediate(()=>{
                    this.isOnceLoad = true
                })
            })
            
            this.saveUpdate(1);
        },
        data(){
            return {
                isTest:Config.isTest,
                eventInitConfigFn: null, // 初始加载配置时
                observer: [], // 向服务端发起保存队列
                penddingObserver: false, // 队列正在排队
                notice: {ico:"",state:false,info:""},
                updateWait: false,

                isOnceLoad: false, // 是否已加载过菜单
                buildCocosFn: null, // 游戏构建弹窗超时处理
                curForms: [], // 当前已选菜单 对应的课件集合
                isInitalNav: false, // 是否是新增的菜单
                // course_web: '', // 课件管理
                heatFn: null, // 心跳计时器
                heatFnOnce: null, // 第一次心跳
                keyBoard: [], // 鼠标当前事件集合
                logRemark: {},
                isContents: true, // 内容区展示
                isSending: false, // 正在发布
                isProgress: false,
                progressValue: 0, // 发布进度
                progressFn: null, // 获取进度计时器
                saveFn: null, // 正在保存事件
                initial: true, // 初始数据
                curCatalog: '', // 当前场景选中的目录(分类)
                oldDetailData: null, // 课件历史数据
                isBeforePackat: false, // 打包之前校验
                curEditItem: {}, // 当前正在编辑的素材配置
                // cocos唤醒素材更多
                isMore: false,
                isCocos: false,
                moreType: '',
                categoryId:'',
                callBack: null, // 回调地址(对象-与cocos约定)

                newMenusData:null,
                showMenu: true, // 左边菜单是否展开
                showType: false, // 右边类型是否展开
                selectedType: '', // 当前展开类型

                // 课程信息
                lessonInfo: {
                    type: 'online',
                    name: this.$route.query.id?'':'高级课件器' + new Date().getMilliseconds(),
                    title: this.$route.query.id?'':'高级课件器'+ (new Date().getMonth() + 1) + new Date().getDate(),
                    cover: '',
                    practiceName: '练习名称'
                },

                // 右击操作按钮
                optItem: null, // 操作右击的数据
                newMouseEnterItem: null, // 鼠标移到的数据元素
                newMouseEnterNav: null, // 鼠标移动到导航内
                newMouseEnterNavItem: null, // 鼠标移动到导航内的元素
                newMouseEnterLessonList:null,//鼠标移动到课件列表空白处
                optIsShow: false,
                optDataTitle:"菜单",
                optData: [{key: 'delete',value: '删除'}, {key: 'move',value: '移动'}, {key: 'copy',value: '复制'}],
                x: 0,
                y: 0,

                // 复制或移动
                isOptType: '', // 操作类型
                isOptToBlock: false,
                optToBlockItem: null,

                isFeedBack: false, // 错误反馈
                feedForm: [
                    {attr: 'name', name: '报错人', value: ''},
                    {attr: 'question_id', name: '报错试题ID', value: ''},
                    {attr: 'subject_id', name: '报错学科', value: ''},
                    {attr: 'type', name: '错误内容', value: '', type: 'radio', options:
                        [
                            {name: '题干', value: 'question'},
                            {name: '答案', value: 'answer'},
                            {name: '解析', value: 'analyze'},
                            {name: '其他', value: 'other'},
                        ]
                    },
                    {attr: 'feedback', name: '纠错反馈', value: '', type: 'textarea'},
                ],

                // 字体编辑位置
                isOperationFont: false,
                oldOperationFont: {},
                newLeft: 0,
                newTop: 0,

                // 说话配置
                isVoiceConfig: false,
                voiceConfig: {},

                // 菜单数据
                menusData: {
                    scenes_stage_id: '', // 当前导航id
                    scenes_state_shop: false, // 当前当行所属我的或公共（默认第一进来是我的）
                    blocksForm: null,
                    blocksSelected: '',
                    lessonSelected: '',
                },

                // 选中的导航id 用于关联出场景
                scenes_stage_id: '',
                op_status: 'save',

                practiceScene: null, // 游戏练习场景
                isWordAudio: false, // 是否是文音组件 默认不是
                selfFlag: {}, // 自定义配置

                operationFn: null, // 操作事件
                operation: [], // 优化批量操作

                fnAddPage: null, // 添加页面function
                isCacheSave:false,
                textVisible:false,
                textData:null
            }
        },
        mounted() {
            const self = this
            // 监听鼠标弹起，向cocos派发事件
            document.addEventListener("mouseup", (e)=>{
                let currKey=0
                e = e||event||window.event;
                currKey = e.keyCode||e.which||e.charCode;
                self.allow2CocosKeboard && self.$toCocosMessage({type: 'KeyBoardEvent', value: {keyCode:currKey, type: 'up'}})
            }, true);
            // 监听f5为预览 ctrl+s为保存
            document.onkeydown = function(e){
                //if(Config.isTest)console.log('onkey==>', e)
                let currKey=0
                e = e||event||window.event;
                currKey = e.keyCode||e.which||e.charCode;

                self.updateKeyBoard({keyCode: `${currKey}`, type: 'down', e})

                self.allow2CocosKeboard && self.$toCocosMessage({type: 'KeyBoardEvent', value: {keyCode:currKey, type: 'down'}})
            }
            document.onkeyup = function(e){
                let currKey=0
                e = e||event||window.event;
                currKey = e.keyCode||e.which||e.charCode;

                self.updateKeyBoard({keyCode: `${currKey}`, type: 'up', e})
                
                self.allow2CocosKeboard && self.$toCocosMessage({type: 'KeyBoardEvent', value: {keyCode:currKey, type: 'up'}})
            }
            // 每5秒向服务器发起一次心跳
            // this.socketHeatBeat()

            // 设置打开的课件id 关掉其他窗体重复打开
            localStorage.setItem('unique', Math.random() + Math.random())

            let id = this.$route.query.id
            if(this.$route.query.is_practice){id = this.$route.query.practice_id}
            localStorage.setItem('openWindow', id)

            this.$nextTick(()=>{
                const app = document.getElementById('app')
                if(this.$route.name === 'main'){
                    app.style.minWidth = '1280px'
                } else {
                    app.style.minWidth = '0px'
                }
                // this.course_web = Config.course_web
            })
            window.addEventListener("beforeunload", e => {
                console.log("运行关闭页面提示！！");
                this.beforeunloadHandler(e);
            });
            window.addEventListener("offline", () => {
                this.$store.state.notice={ico:"el-icon-error",state:true,info:"您的网络已经断开，请连接网络后在编辑"};
            });
            window.addEventListener("online", () => {
                this.$store.state.notice={ico:"el-icon-success",state:true,info:"网络已经连接，尝试上传本地数据；"};
                this.saveUpdate(0);
            });
            document.addEventListener("visibilitychange", function() {
                console.log("当前窗口状态：",document.visibilityState);
                if (document.visibilityState === 'visible') {
                    self.listData();
                    self.saveUpdate(0);
                } else {
                    self.listData();
                }
            });
            //window.removeEventListener('storage', this.listData());//先移除本地数据监听，防止重复注册产生BUG
            //window.addEventListener('storage', this.listData());//开始监听本地数据
            this.init();
        },
        methods: {
            ...mapActions(['setSendKeyBoardToCocos']),
            init(){
                if(this.isPractice) {
                    if(this.$route.query.id){
                        this.getOldConfig({id: this.$route.query.id, type: 'only'})
                    }
                    // 如果游戏练习id存在 则获取游戏练习历史记录
                    if(this.isPracticeId){
                        this.getOldConfig({practice_id: this.$route.query.practice_id})
                    } else {
                        this.saveConfig(true)
                        this.initDone()
                        // this.$store.state.initial = false
                    }
                    // 刷新练习场景
                    this.wevGetGlobalCommon({}, 'only')
                    // this.initDone()
                    console.log('event==>', 1)
                    return false
                }
                // 获取初始化导航及课程配置数据
                if(this.$route.query.id){
                    this.getOldConfig({id: this.$route.query.id})
                } else {
                    // 获取导航数据
                    // 如果当前没有课程id,及时新增课件id
                    this.getNavList(()=>{
                        this.saveConfig(true)
                        // this.$store.state.initial = false
                        this.initDone()
                    })
                }
                // this.initDone()
                // let isOld = LocalStorage.getConfig()
                // // 如果配置表存在复制，则提示是否粘贴
                // if(isOld && !this.$route.query.is_practice){
                //     this.copyConfig()
                // }
                //console.log('event==>', 2)
            },
            // 初始化完成
            initDone(){
                this.$nextTick(()=>{
                    if(!this.$store.state.menusData.blocksForm){
                        this.$store.state.menusData.blocksForm = []
                    }
                })
            },
            // 游戏配置是否正在保存中
            isGameSaving(){
                let state = false
                if(this.editGameConfig
                    && this.editGameConfig.configStatus
                    && this.editGameConfig.configStatus.writeUntil
                ) {
                    let time = this.editGameConfig.configStatus.writeUntil || 0
                    let sub = time - Date.now()
                    state = sub>0 ? sub: false
                }
                return state
            },
            
            getHeart () {
                const heartStr = this.heartStr;
                const func = async () => {
                    const res = await resultServer.getHeart(heartStr)
                    if (res.status_code === 200) {
                        let timeHeart = setTimeout(() => {
                            func()
                            clearTimeout(timeHeart)
                        }, 10000)
                    } else {
                        this.$confirm('该账号已在其他入口登录!', '提示', {
                            showCancelButton: false,
                            closeOnPressEscape: false,
                            closeOnClickModal: false,
                            type: 'warning',
                            confirmButtonText: '退出',
                            callback: () => {
                                this.closeWindow()
                            },
                            beforeClose: () => {
                                this.closeWindow()
                            }
                        })
                    }
                }
                func()
            },
            closeWindow(){
                window.opener=null;
                window.close();
            },
            // 执行添加页面
            excFnAddPage(){
                const fn = setTimeout(()=>{
                    if(this.fnAddPage){
                        this.fnAddPage()
                        this.fnAddPage = null
                    }
                    clearTimeout(fn)
                }, 200)
            },
            // 收集保存队列
            observerPrettify(isCocos,callback, operation, isPublish, flag){
                this.observer.push({isCocos,callback, operation, isPublish, flag})
                this.excObserver()
            },
            excObserver(){
                const obj = this.observer.shift()
                const {isCocos,callback, operation, isPublish, flag} = obj
                if(!this.penddingObserver && obj) {
                    this.penddingObserver = true
                    this.prettifySave(isCocos, callback, operation, isPublish, flag)
                }
            },
            // 优化保存
            async prettifySave(isCocos,callback, operation, isPublish, flag){
                //console.log('prettifySave', isCocos,callback, operation, isPublish, flag)
                __log__.push({type: 'operation',operation})
                let obj = this.getConfigData()
                // 如果名称和标题同时不存在，不允许操作
                if(!obj.name && !obj.title){
                    this.penddingObserver = false
                    return false
                }

                obj.method = 'post'
                delete obj.attributes
                delete obj.op_status
                if(isPublish || ['beforeSend', 'preview', 'save'].includes(flag)) obj.flag = 'publish'
                this.operation = this.operation.concat(operation)
                //console.log('优化保存==>', obj, this.$route.query.id, isCocos,callback,operation, Date.parse(new Date()))
                __log__.push({type: 'toPHP', operation})

                const time = new Date().getTime()
                __log__.push({type: 'toPrettifySave',time})

                // TODO 真实请求优化接口
                const fn = async (obj, operation)=> {
                    const excCallBack = ()=>{
                        // 保存成功执行回调 - 默认一定保存成功
                        callback && callback()
                    }

                    const id =  obj.id || this.$route.query.id
                    if(id && flag!=='preview') excCallBack()
                    let res = null
                    if (this.isPractice) {
                        // 游戏练习如果practice_id存在时，走编辑接口 否则走新建接口
                        if (this.isPracticeId) {
                            console.log('999==>', obj, obj.id>0)
                            if(obj.id>0) res = await commonServer.default.updateExerciseGame(obj)
                        } else {
                            // 5秒内禁止重复新建
                            if(!this.$utils.isFastExecute(200)) res = await commonServer.default.addExerciseGame(obj)
                        }
                    } else if (this.$route.query.id) {
                        let newObj = {id: this.$route.query.id, ...obj}
                        if (this.isTemplate) {
                            if(newObj.id>0) res = await commonServer.default[this.updateResource](newObj)
                        } else {
                            __log__.push({type: 'operation1',operation:JSON.parse(JSON.stringify(newObj))})
                            if(newObj.id>0) res = await resultServer.updateResult(newObj)
                        }
                    } else {
                        if (this.isTemplate) {
                            res = await commonServer.default[this.addResource](obj)
                        } else {
                            res = await resultServer.addResult(obj)
                        }
                    }
                    if(!id || flag==='preview') excCallBack()

                    // if (res && res.status_code === 200) {
                        !isCocos && this.$message.success('保存成功', this.$route.query.id)

                        if (this.isPractice) {
                            if (!this.isPracticeId) {
                                this.isInitalNav = true
                                res && this.$RouteUtil.main({...this.$route.query, practice_id: res.data.id || 1})
                            }
                        }
                        // 如果id不存在则 保存成功把id赋值在上面，下次保存就是编辑
                        else if (!this.$route.query.id) {
                            this.isInitalNav = true
                            res && this.$RouteUtil.main({...this.$route.query, id: res.data.id})
                        }
                        if (this.$refs.top) {
                            this.$refs.top.isEditName = false
                            this.$refs.top.isEditTitle = false
                        }
                    // } else {
                    //     !isCocos && this.$message.error('保存失败')
                    // }

                    // 判断当前操作如果还有未完成操作，则再向服务端请求下操作动作
                    // console.log('operation==>2', this.$_.cloneDeepWith(this.operation).length)
                    const newObj = obj
                    const newOperation = operation || this.operation
                    if(newOperation && newOperation.length){
                        newObj.actions = this.$_.cloneDeepWith(newOperation)
                        console.log('继续请求==>', newObj)
                        const len = newOperation.length
                        this.operation = newOperation.splice(len)
                        fn(newObj, this.operation)
                    }
                }

                //console.log('优化速度==>prettifySave')

                clearTimeout(this.operationFn)
                this.operationFn = setTimeout(()=>{
                    obj.actions = this.$_.cloneDeepWith(this.operation)
                    const len = this.operation.length
                    this.operation = this.operation.splice(len)
                    fn(obj, len)
                    console.log("this.operation",this.operation);
                    clearTimeout(this.operationFn)
                }, 200)

                this.penddingObserver = false
            },
            // 当前菜单选中 里面的课件总数
            onCurForm(data){
                this.curForms = data
                if(data?.length === 0){
                    console.log('retro lessonSelected1')
                    this.$store.state.menusData.lessonSelected = ''
                    this.$store.state.menusData.lessonSelectedConfig = {}
                    this.$store.state.isCocosSaving = false
                }
            },
            // 获取游戏练习场景
            onPracticeScene(){
                this.$store.state.menusData.willGo = this.$store.state.menusData.lessonSelected
                this.$toCocosMessage({type: 'SaveConfig', value: {flag: 'changeMenu'}})
            },
            // 向服务器发起心跳
            socketHeatBeat(){
                clearInterval(this.heatFn)
                clearImmediate(this.heatFnOnce)
                const id = this.$route.query.id
                if(id){
                    this.heatFnOnce = setImmediate(()=>{
                        this.realHeatBeat(id)
                        clearImmediate(this.heatFnOnce)
                    })
                    this.heatFn = setInterval(()=>{
                        this.realHeatBeat(id)
                    }, 5000)
                }
            },
            // 真正心跳发生
            async realHeatBeat(id){
                const userInfo = this.$store.state.userInfo ? this.$store.state.userInfo : {...this.$store.state.userInfoTwo, ...this.$store.state.userInfoTwo.as_agent}
                const obj = {
                    result_id: id,
                    source: this.source,
                    user_id: userInfo.id
                }
                try {
                    // 维护一个当前课件/模版对应的实时时间戳，来判断当前是否正在被编辑
                    const key = `${userInfo.id}_${this.source}_${id}`
                    let courseAuthList = LocalStorage.getCourseToken() || {}
                    if(typeof courseAuthList === 'string' && courseAuthList.indexOf(',') === -1){
                        courseAuthList = {}
                    } else if(typeof courseAuthList === 'string'){
                        courseAuthList = JSON.parse(courseAuthList)
                    }
                    if(courseAuthList[key] && (Date.parse(new Date()) - courseAuthList[key].timestamp)<10000){
                        obj.course_auth_token = courseAuthList[key].course_auth_token
                    }
                    const res = await GlobalServer.getHeatBeat(obj)
                    if(res && res.status_code === 200){
                        let newCourseAuthList = courseAuthList
                        newCourseAuthList[key] = {
                            course_auth_token: res.data.course_auth_token,
                            timestamp: Date.parse(new Date)
                        }
                        LocalStorage.setCourseToken(JSON.stringify(newCourseAuthList))
                    }
                } catch (e) {
                    console.log('获取失败==>', e)
                    // LocalStorage.removeCourseToken()
                }
            },
            // 问题反馈
            onFeedBack(item){
                console.log('问题反馈==>', item)
                this.isFeedBack = true
                this.feedForm[0].value = this.$store.state.userInfo.name
                this.feedForm[1].value = item.id
                this.feedForm[2].value = this.$enums.gradeEmum[item.grade_id] + this.$enums.subjectEmum[item.subject_id]
                this.feedForm[2].subject_id = item.subject_id
                this.feedForm[2].grade_id = item.grade_id
            },
            // 关闭背景音弹窗
            closeBackAudio(){
                if(this.$refs.content) this.$refs.content.isVoiceChange = false
            },
            // cocos所有课件对应的配置
            cocosConfig(){
                // 将当前的最新配置存入menusData
                // const lessonSelected = this.$store.state.menusData.lessonSelected
                // if(lessonSelected && Array.isArray(this.curForms)){
                //     let node = this.$store.state.menusDataIds[this.$store.state.menusData.blocksSelected] //this.$utils.curSelectedNode({})
                //     if(node) node.children = this.curForms
                // }
                const data = this.$store.state.menusData
                let newConfig = []
                try {
                    newConfig = this.$cocosUtils.cocosConfig({data: this.$_.cloneDeepWith(data), ids: this.menusDataIds})
                }catch (e) {
                    console.log('获取失败cocos所有配置==>', e)
                }
                return newConfig
            },
            onCancel(){
                this.fnAddPage = null
            },
            // 初始创建导航默认创建一个空白页面
            autoAddPage(){
                // console.log('777=>', this.$refs.menus)
                // debugger
                this.$refs.menus && this.$refs.menus.add(0, 'flash')
            },
            // 添加页面
            addPage(){
                if(this.fnAddPage){
                    this.$message.warning('正在初始化构建中，请稍后')
                    return false
                }
                let fn = ()=>{
                    this.$refs.menus && this.$refs.menus.add(0, 'flash')
                    this.fnAddPage = null
                }
                this.fnAddPage = fn
                // 1.如果没有导航，默认先弹出创建导航
                if(this.$store.state.menusData.blocksForm && this.$store.state.menusData.blocksForm.length === 0) {
                    // 2.创建导航后默认创建第一个空菜单
                    // const {id, practice_id} = this.$route.query
                    const obj = {}
                    // if(id || practice_id){
                        obj.fn = fn
                    // }
                    this.onAdd(obj)
                    return false
                }
                fn()
            },
            // 添加导航
            onAdd({fn, addPage}){
                this.onOperation({key: 'addNavItem', fn, addPage})
            },
            // 编辑导航
            onEdit (item) {
                console.log('编辑==>', item)
                this.optItem = item
                this.onOperation({key: 'editNavItem', ...item})
            },
            // 删除导航
            onDelete (item) {
                console.log('删除==>', item)
                this.optItem = item
                this.onOperation({key: 'deleteNavItem', ...item})
            },
            // 当前配置如果有数据 则自动保存
            isHasData(data){
                let state = false
                // console.log('当前配置==>', data)
                data && data.map(v=>{
                    if(v.children && v.children.length>0) state = true
                })
                return state
            },
            // 获取历史数据
            async getOldConfig({id, practice_id, type}){
                // 如果是编辑模版，获取模版数据
                let res = null
                let newData = null
                const config_type = 'web_edit'
                //console.log("如果是编辑模版，获取模版数据");
                if(practice_id){
                    res = await commonServer.default.queryExerciseGameDetail({
                        id: practice_id,
                        clientsId: this.$store.state.initConfig.school_id,
                        config_type
                    })
                    newData = this.$utils.jsonStr2Json(res.data.attributes.h5_remote)
                    this.practiceScene = res.data.attributes.cocos_style
                } else if(`${this.$route.query.is_template}` === 'true'){
                    res = await commonServer.default[this.getResourceDetail]({
                        id,
                        clientsId: this.$store.state.initConfig.school_id,
                        config_type
                    })
                    console.log("this.getResourceDetail",this.getResourceDetail);
                    newData = res.data.attributes.h5_remote
                } else {
                    res = await resultServer.getResultDetail({
                        id,
                        clientsId: this.$store.state.initConfig.school_id,
                        config_type
                    })
                    newData = res.data.attr_last.h5_remote
                }

                // 保存历史详情数据
                this.oldDetailData = res && res.data

                // TODO 模版的历史数据
                // console.log(res)
                // debugger

                // 计费标记
                if(res.data.attr_last && res.data.attr_last.h5_original) {
                    this.$store.dispatch('setNewUrlMap', res.data.attr_last.h5_remote.urlMap)
                }
                console.log('兼容旧数据==>', typeof newData)
                if(typeof newData === 'string'){
                    newData = JSON.parse(newData)
                }
                // 兼容旧数据，旧数据只有一级菜单，需要给每个一级菜单加上唯一unique值
                newData = this.clacNewData({data: newData})

                // 将整颗树 拆成 两颗
                const {menusIds} = this.$utils.one2TwoTree({data: newData})

                // 如果菜单中存在重复unique,重新计算
                // newData.blocksForm = this.$utils.calcNavIsUnique({data: newData.blocksForm})
                if(type !== 'only'){
                    this.$store.state.menusData = newData
                    this.$store.state.menusDataIds = menusIds
                }

                this.lessonInfo.name = res.data.name
                this.lessonInfo.title = res.data.title
                this.lessonInfo.type = res.data.type
                this.lessonInfo.cover = res.data.cover

                if(this.isPractice) this.lessonInfo.practiceName = res.data.name

                // 如果当前菜单没选中任何目录，则默认选中第一目录的所有第一个子菜单
                this.defaultSelectMenu()

                // this.$store.state.initial = false
                // this.flashContent(true)
            },
            // 处理旧数据菜单没有unique
            clacNewData({data}){
                data.blocksForm.map(v=>{
                    if(!v.unique){
                        v.unique = Math.random()
                    }
                })
                // console.log(data)
                // debugger
                return data
            },
            // 获取导航数据
            async getNavList(fn){
                try {
                    const res = await commonServer.default[this.getResourceList]({
                        clientsId:this.$store.state.initConfig.school_id,
                        sort:'scenes_stage',
                        page: 1,
                        perPage: 1,
                    })
                    console.log('获取导航数据', res)
                    // TODO 获取默认导航
                    this.scenes_stage_id =  res.items[0].id
                    this.$store.state.menusData.scenes_stage_id = this.scenes_stage_id
                    this.$store.state.menusData.scenes_state_shop = this.isShop
                    // const options = this.$utils.addIdByArr({parentNode:this.$store.state.menusData.blocksForm, data:res.items[0].attributes.options})
                    const options = res.items[0].attributes.options
                    this.$store.state.menusData.blocksForm = options.map((v,i)=>{
                        let obj = {
                            id: `${i}`,
                            url: '',
                            name: v,
                            children: []
                        }
                        if(typeof v === 'object'){
                            obj = {...obj, ...v}
                        }
                        // 兼容旧数据导航
                        if(!obj.unique){
                             obj.unique = Math.random() + i
                        }
                        return obj
                    })

                    // 如果菜单中存在重复unique,重新计算
                    this.$store.state.menusData.blocksForm = this.$utils.calcNavIsUnique({data: this.$store.state.menusData.blocksForm})

                    const {menusData, menusIds} = this.$utils.one2TwoTree({data: this.$store.state.menusData})
                    this.$store.state.menusData = menusData
                    this.$store.state.menusDataIds = menusIds

                    // 初始化配置
                    const operation = [
                        {data:this.$store.state.menusData,operation: 'initConfig'}
                    ]

                    // 初始化配置，挂载在游戏引擎加载完后执行
                    this.eventInitConfigFn = ()=>{ $eventBus.$emit('__save__',true,null, operation) }

                    // 通知cocos侧配置
                    // this.$toCocosMessage({type: 'GetConfig', value: this.cocosConfig()})
                    fn && fn()

                    // 如果当前菜单没选中任何目录，则默认选中第一目录的所有第一个子菜单
                    this.defaultSelectMenu()
                } catch (e) {
                    console.log('等待获取导航==>', e)
                    fn && fn()
                }
            },
            // 如果当前菜单没选中任何目录，则默认选中第一目录的所有第一个子菜单
            defaultSelectMenu(state){
                if(!this.$store.state.menusData.blocksSelected || state){
                    let obj = {}
                    obj = this.firstMenu({target: obj,data: this.$store.state.menusData.blocksForm})
                    this.$store.state.menusData.blocksSelected = obj.unique

                    const data = this.menusDataIds[obj.unique] &&
                        this.menusDataIds[obj.unique].children &&
                        this.menusDataIds[obj.unique].children[0]

                    if(data){
                        console.log('retro lessonSelected2')
                        this.$store.state.menusData.lessonSelected = data.unique
                        this.$store.state.menusData.lessonSelectedConfig = {type: data.type}
                        this.webloadCompletedH5()
                    }
                }
            },
            firstMenu({target, data}){
                data.map((v,i)=>{
                    if(i===0 && v.unique){
                        target.unique = v.unique
                        if(v.leaf && v.leaf.length>0){
                            this.firstMenu({target, data: v.leaf})
                        }
                    }
                })
                return target
            },
            // 监听cocos侧发过来的通知
            messageEvent(){
                getMessage(this.eventsList)
            },
            eventsList(e){
                // console.log('接收==>', e)
                let type = ''
                let {data} = e

                // course侧向web发出通知
                if(data.type && data.type.substr(0,6)==='course') {
                    console.log('向web侧发出3：' + data.type + '消息==>', e)
                    // 同步token
                    this.$store.state.initConfig.client_id = data.value.client_id
                    LocalStorage.setToken(data.value.token)
                }
                // 模拟向cocos侧发出通知
                if(data.type && data.type.substr(0,5)==='cocos'){
                    console.log('向cocos侧发出：'+data.type+'消息==>', e)
                }

                // cocos侧向web发出通知
                if(data.type && data.type.substr(0,3)==='web'){
                    // console.log('向web侧发出1：'+data.type+'消息==>', e)
                    type = data.type.substr(3)
                    //console.log('向web侧发出1-1：', type)
                    //console.timeEnd(`[耗时]向cocos发消息到接收消息==>${type}`)
                    switch (type) {
                        case 'AudioPause':
                            AudioPause()
                            break
                        case 'GetGlobalCommon':
                            this.wevGetGlobalCommon({...data})
                            break
                        case 'keyBoardEvent':
                            this.webKeyBoardEvent({...data})
                            break
                        case 'EditFont':
                            data.value && this.webEditFont({...data})
                            break;
                        case 'EditText'://富文本编辑处理，支持属性：color,size,outline,b,i,u,br；不用属性：on,param,img
                            data.value && this.webEditText({...data})
                            break;
                        case 'GoToKejian':
                            this.webGoTokejian(data.value)
                            break;
                        case 'GetConfig':
                            this.webGetConfig(data.value)
                            break;
                        case 'EditResource':
                            this.webEditResource(data)
                            this.focusFront()
                            break;
                        case 'DelResource':
                            this.webDelResource(data.value)
                            break;
                        case 'EditNote':
                            this.webEditNote({...data})
                            this.focusFront()
                            break;
                        case 'SaveConfig': {
                            //console.timeEnd(`[耗时]向cocos发消息到接收消息==>Lesson=>Save`)
                            this.$store.state.isCocosSaving = false
                            //console.log('当前==>1', data.value, this.$store.state.menusData.lessonSelected)

                            const time = new Date().getTime()
                            __log__.push({type: 'toWebSaveConfig',time})

                            // 如果正在发布 不允许触发保存
                            if(this.isBeforePackat) return false

                            this.$colorLog({4: 'webSaveConfig'})
                            clearTimeout(this.saveFn)
                            this.saveFn = setTimeout(() => {
                                this.$store.dispatch('setSaving', false)
                            }, 300)
                            this.webSaveConfig(data.value)
                            // this.$refs.menus.flashLesson()
                            break;
                        }
                        case 'ShowWarn': {
                            this.webShowWarn(data.value)
                            break;
                        }
                        case 'loadCompletedH5':
                            this.webloadCompletedH5()
                            break;
                        case 'BuildConfigCopmlete': {

                            const time = new Date().getTime()
                            __log__.push({type: 'BuildConfigCopmlete',time})

                            //console.timeEnd(`[耗时]向cocos发SaveConfig==>Complete`)
                            //console.timeEnd(`[耗时]从切换菜单到游戏渲染完成总耗时`)
                            this.$colorLog({2: 'webBuildConfigCopmlete'})
                            // 页面渲染完成，配合getlessionconfig 发出使用
                            this.$store.dispatch('setSaving', false)
                            const fn = setTimeout(()=>{
                                this.$store.dispatch('setIsBuilding', false)
                                clearTimeout(fn)
                            }, 800)
                            break;
                        }
                        case 'EditGameConfig': {
                            this.$store.dispatch('setGameConfig', data.value)
                            break;
                        }
                        case 'EditBgm': {
                            this.webEditBgm({...data})
                            this.focusFront()
                            break;
                        }
                        case 'GetToken':
                            this.GetToken({...data})
                            break;
                        default:
                    }
                }
            },
            // 向cocos发出token和client_id
            GetToken(data){
                const token = VueCookie.get(authCookie.token)
                const client_id = VueCookie.get(authCookie.client_id)
                this.$toCocosMessage({...data, type: 'GetToken', value: {token, client_id}})
            },
            // 前端侧拿到焦点
            focusFront(){
                document.querySelector("#focus").focus()
            },
            // 选择场景
            webEditScenes(obj, data){
                this.moreType = 'gameScenes'
                this.curCatalog = obj.value
                this.isMore = true
                this.callBack = data.callback
            },
            // 选择图片
            webEditImage(obj, data){
                this.moreType = 'image'
                this.curCatalog = obj.value
                this.isMore = true
                this.callBack = data.callback
            },
            // 选择视频
            webEditVideo(obj, data){
                this.moreType = 'video'
                this.curCatalog = obj.value
                this.isMore = true
                this.callBack = data.callback
            },
            // 游戏编辑提示语
            webShowWarn(data){
                $eventBus.$emit('showWarn', data || {})
            },
            updateTextFont(data){
                console.log("确定后提交COCOS：",data);
                this.$toCocosMessage({index:data.index,type: "EditText", value:data.value})
            },
            // 保存当前编辑的配置
            webSaveConfig(data){
                console.log('切换==>', data, data.flag)
                let isPublish = false // 当前是否是发布前保存
                this.op_status = 'save'
                // debugger
                // 当前为预览时或切换菜单 - 由cocos执行
                let func = ()=>{
                    if(this.$store.state.waitBackgourndVideo){
                        this.$store.state.waitBackgourndVideo = false
                        const fn = setTimeout(()=>{
                            this.$refs.menus.flushLeeson(true)
                            clearTimeout(fn)
                        }, 1000)
                    }
                    // 处理添加游戏 菜单自动滚到顶问题
                    // const state = (data && data.type === 'game') ||(data && data.flag && data.flag.type === 'addGame')
                    // this.$refs.menus && this.$refs.menus.flashLesson && this.$refs.menus.flashLesson(state)

                    // 添加游戏，判断是否是当前最后一个， 如果是自动往下滚一个菜单
                    // const fn = setTimeout(()=>{
                    //     this.$refs.menus && this.$refs.menus.autoScrollNext({})
                    //     clearTimeout(fn)
                    // }, 800)
                }
                switch(data.flag){
                    case 'quit':{
                        func = () => {
                            window.location.href="about:blank"
                            window.close()
                        }
                        break
                    }
                    case 'beforeSend':{
                        isPublish = true
                        this.op_status = 'save'
                        func = () => this.beforeSend()
                        break
                    }
                    case 'preview':{
                        func = () => this.preview()
                        break
                    }
                    case 'changeMenu':{
                        // 1.获取配置
                        this.$store.state.operationSteps.push(this.$enums.operationStep.getConfig)

                        const lessonUnique = this.$store.state.menusData.willGo
                        const leesonConfig = this.$store.state.menusData.willGoConfig
                        const blocksSelected = this.$store.state.menusData.willGoBlock
                        func = () => {
                            console.log('999优化速度==>进入changeMenu', blocksSelected, lessonUnique)
                            this.$store.state.menusData.blocksSelected = blocksSelected
                            // 2.切换菜单
                            this.$store.state.operationSteps.push(this.$enums.operationStep.changeMenu)

                            console.log('retro lessonSelected3')
                            this.$store.state.menusData.lessonSelected = lessonUnique
                            this.$store.state.menusData.lessonSelectedConfig = leesonConfig

                            this.$store.state.menusData.willGo = ''
                            this.$store.state.menusData.willGoConfig = {}

                            // 切换菜单 游戏配置清空
                            this.$store.state.editGameConfig = null
                            let obj = this.menusDataIds[lessonUnique]
                            if(lessonUnique && obj) {
                                console.time(`[耗时]向cocos发消息到接收消息==>Lesson=>Save`)
                                console.log('优化速度changeMenu==>GetLessonConfig')
                                console.log('retro=>向cocos发配置2')
                                this.$store.dispatch('setIsBuilding', true)
                                this.$toCocosMessage({type: 'GetLessonConfig', value: getRandomByObj(obj)})
                            } else {
                                this.$store.dispatch('setIsBuilding', true)
                                this.$toCocosMessage({type: 'GetLessonConfig', value: this.$store.state.addEmptyConfig})
                            }
                            // setTimeout(()=>{
                            //     // 如果当前目录不存在 当前课件 刷新下课件列表
                            //     let node = this.menusDataIds[blocksSelected]
                            //     let state = true
                            //     node.children.map(v=>{if(v.unique === lessonUnique){state = false}})
                            //     if(state) {
                            //         this.$store.state.menusData.lessonSelected = lessonUnique
                            //         this.$refs.menus.flushLeeson()
                            //     }
                            // }, 5000)
                            this.$refs.menus.flashLesson()
                        }
                        break
                    }
                    case 'changeMenuItem': {
                        const lessonUnique = this.$store.state.menusData.willGo
                        const leesonConfig = this.$store.state.menusData.willGoConfig
                        func = this.changeMenuItem({lessonUnique, leesonConfig})
                        break
                    }
                    case 'save' : {
                        this.op_status = 'save'
                        func = () => {
                            this.$message.success('保存成功')
                        }
                        break
                    }
                    case 'setGameConfig': {
                        func = this.setGameConfig
                        break
                    }
                }
                if(typeof data.flag === 'object' && data.flag.type === 'add'){
                    func = () => {
                        this.$refs.menus && this.$refs.menus.realAdd({...data.flag})
                    }
                }
                // 导入ppt 转成菜单数据
                if(typeof data.flag === 'object' && data.flag.type === 'ppt'){
                    func = () => {
                        console.log('6968==>2', {...data.flag})
                        this.$refs.menus && this.$refs.menus.realImportPPT({...data.flag})
                        // this.$refs.content && this.$refs.content.flashPPTList && this.$refs.content.flashPPTList()
                        // const fn2 = setTimeout(()=>{
                        //     this.flashContent()
                        //     clearTimeout(fn2)
                        // }, 1000)
                    }
                }
                // 添加游戏，需要先保存
                if (data.flag && data.flag.type === 'addGame' && data.flag.unique && data.flag.unique === this.$store.state.addGameTempObj.unique) {
                    // 通知服务端新增一节游戏
                    const operation = [{node: 'children', toUnique:this.$store.state.menusData.lessonSelected,data:this.$store.state.addGameTempObj.data,leafUnique:this.$store.state.menusData.blocksSelected, operation: 'add'}]
                    $eventBus.$emit('__save__',true,null, operation)
                    this.$store.dispatch('addOneMenuData', this.$store.state.addGameTempObj.data)
                    this.$refs.menus.flashLesson()
                }
                console.log('尝试更新当前选中课程的配置', this.$store.state.menusData.lessonSelected, data, this.$store.state.menusData, func)
                // debugger
                let opts = ''
                try {
                    if(data.unique) {
                        // 发布之前 更新当前游戏配置
                        // this.$utils.getObjByCurLesson({
                        //     newData: data,
                        //     type: 'update',
                        //     unique: data.unique
                        // })
                        this.menusDataIds[data.unique] = data

                        /**/this.curForms.map((v,i)=>{
                            if(`${v.unique}` === `${data.unique}`){
                               this.curForms[i] = data
                            }
                        })/**/

                        opts = [{node: 'children', toUnique: data.unique, data, operation: 'edit'}]

                        // console.log('获取当前课程==>', data, lessonNode, this.$store.state.menusData.lessonSelected)

                        // 刷新菜单数据
                        //console.log('刷新菜单数据==>', this.curForms,"this.menusDataIds:",this.menusDataIds, this.$store.state.menusDataIds, this.$store.state.menusData)
                        this.$refs.menus.setLessonForm({data: this.curForms})
                        
                        // 如果当前的菜单有背景图，刷新菜单数据
                        /*if (data && data.theme && data.theme.background && data.theme.background.url) {

                            console.log('78783==>', this.curForms)
                            this.$refs.menus && this.$refs.menus.setLessonForm({data: this.curForms})
                            console.log('78784==>')
                        }*/

                        //console.log('func==>')

                        const time = new Date().getTime()
                        __log__.push({type: 'func==>',time})
                        // 如果当前未选中，则直接执行回调
                        if(!this.$store.state.menusData.lessonSelected){
                            opts = []
                        }
                    }
                    // 保存到服务器
                    // if (this.$route.query.id) {
                    this.saveConfig(true, func, opts, isPublish, data.flag)
                    // } else if (this.$route.query.is_template) {
                    //     this.saveConfig(true, func)
                    // }
                }catch (e) {
                    console.log('保存当前配置失败1==>', e)
                }
            },
            // 设置游戏场景为默认配置
            async setGameConfig(){
                try {
                    const node = this.menusDataIds[this.$store.state.menusData.lessonSelected]
                    const {config: {config_common: {rawConfig}, form_id_common, form_id_scenes}} = node
                    console.log('游戏配置==>', form_id_common, rawConfig, node)
                    // 2.备份一份游戏通用配置
                    // 3.修改游戏通用配置
                    await commonServer.default.copyForm({
                        id: form_id_common,
                        clientsId: this.$store.state.initConfig.school_id
                    })
                    const res = await commonServer.default.getFormDetail({id: form_id_common})
                    const { data: {id, type, category_id:categoryId, name, remark, allow_create:allowCreate, options}} = res
                    const obj = {
                        id,
                        type,
                        categoryId,
                        name,
                        remark,
                        allowCreate,
                        options
                    }
                    console.log(JSON.parse(obj.options))
                    let newOptions = options
                    const config_common_original = this.$utils.getArrByDiy({obj: newOptions})
                    const oldObj = this.$utils.getObjByArr({data: config_common_original})
                    const key = `rawConfig-${form_id_scenes}`

                    let index = -1
                    // 添加
                    newOptions = JSON.parse(newOptions)
                    if(oldObj[key]){
                        // 修改
                        newOptions.layout.map(
                            (v, i)=>{
                                if(v && v.config && v.config[0] && v.config[0].attr === key){
                                    index = i
                                }
                            }
                        )
                        newOptions.layout[index].config[0].value = rawConfig
                        obj.options = JSON.stringify(newOptions)
                    } else {
                        newOptions.layout.map(
                            (v, i)=>{
                                if(v && v.config && v.config[0] && v.config[0].attr){
                                    index = i
                                }
                            }
                        )
                        let item = this.$_.cloneDeepWith(newOptions.layout[index])
                        item.config[0].attr = key
                        item.config[0].key = Math.random()
                        item.config[0].value = rawConfig

                        const layout = JSON.parse(options).layout.concat([item, {}])
                        let mergeOptions = JSON.parse(options)
                        mergeOptions.layout = layout
                        obj.options = JSON.stringify(mergeOptions)
                    }
                    const result = await commonServer.default.updateForm(obj)
                    if(result.status_code === 200) {
                        this.$message.success('设置成功')
                    }
                } catch (e) {
                    console.log('设置失败原因==>', e)
                    this.$message.error('设置失败')
                }

            },
            // 切换课件
            changeMenuItem({lessonUnique, leesonConfig, isDoing}){
                const func = ()=>{
                    console.log('retro lessonSelected4')
                    this.$store.state.menusData.lessonSelected = lessonUnique
                    // this.$store.state.menusData.lessonSelectedConfig = leesonConfig
                    this.$set(this.$store.state.menusData, 'lessonSelectedConfig', leesonConfig)
                    // 切换菜单 游戏配置清空
                    this.$store.state.editGameConfig = null
                    let obj = this.menusDataIds[lessonUnique]
                    if(lessonUnique && obj) {
                        console.timeEnd(`[耗时]向cocos发SaveConfig==>Config`)
                        console.log('优化速度changeMenuItem==>GetLessonConfig=>', new Date().getTime())
                        console.log('retro=>向cocos发配置3')
                        this.$store.dispatch('setIsBuilding', true)
                        this.$toCocosMessage({type: 'GetLessonConfig', value: getRandomByObj(obj)})
                    }
                }
                if(isDoing){
                    func()
                }
                return func()
            },
            // cocos初始化加载通知web侧拿选中配置
            webloadCompletedH5(){
                if(this.eventInitConfigFn){
                    this.eventInitConfigFn()
                    this.eventInitConfigFn = null
                }
                console.log('event==>', 3)
                // console.log('甲等==>', this.$store.state.menusData)
                this.$store.state.saving = false

                let fn = setTimeout(() => {
                    this.$store.state.initial = false
                    clearTimeout(fn)
                }, 800)
                try {
                    // if (this.$store.state.menusData.blocksForm.length === 0) {
                    //     return false
                    // }
                    // let data = this.$store.state.menusData.blocksForm.length>0?this.$store.state.menusData: this.newMenusData
                    // let arr = data.lessonSelected.split('/')
                    // // setTimeout(()=>{
                    // let value = data.blocksForm[arr[0]].children[arr[1]]
                    // console.log('完成加载==>')

                    console.log('优化速度==>loadCompletedH5')
                    // 获取当前选中课程
                    let obj = this.$utils.getObjByCurLesson({})
                    let newObj = this.menusDataIds[this.$store.state.menusData.lessonSelected]
                    if (newObj) {
                        obj = {...obj, ...newObj}
                    }
                    console.log('1028==>', obj, getRandomByObj(obj), newObj)

                    this.$store.state.isBuildCocos = true
                    console.log('优化速度loadCompletedH5==>GetLessonConfig', this.$store.state.isBuildCocos, obj)
                    console.log('retro=>向cocos发配置4', this.menusData)

                    // 4.向cocos发出新的课件config
                    this.$store.state.operationSteps.push(this.$enums.operationStep.toConfig)
                    this.$store.dispatch('setIsBuilding', true)
                    this.$toCocosMessage({type: 'GetLessonConfig', value: getRandomByObj(obj)})
                    // },300)
                } catch (e) {
                    console.log('保存当前配置失败2==>', e)
                }
            },
            // 编辑背景音
            webEditBgm(data){
                console.log('webEditBgm==>', data)
                if(this.$refs.content && this.$refs.content.setVoiceConifg){
                    this.$refs.content.setVoiceConifg({data})
                }
            },
            // 编辑富文本框
            webEditNote(data){
                this.$refs.content.handleEdit(data)
            },
            // 获取全局表单配置数据 type为only时，刷新列表
            async wevGetGlobalCommon(data, type){
                const key = data.value
                let obj = this.$store.state.cocos_global_common
                if(!obj|| obj.length<=0) {
                    let newObj = {}
                    const res = await commonServer.default['getFormList']({
                        type: 'global_common',
                        perPage: 100,
                        page: 1
                    })
                    res.items.map(v => {
                        newObj[`${v.name}`] = this.$utils.getObjByArr({data: this.$utils.getArrByDiy({obj: v.options})})
                        newObj[`${v.name}Remark`] = {key: v.name, value: v.remark}
                    })
                    this.$store.state.cocos_global_common = newObj
                    if(type === 'only') return false
                }
                let value = this.$store.state.cocos_global_common[key]
                this.$toCocosMessage({type: 'GetGlobalCommon',...data, value})
            },
            // 监听鼠标事件
            webKeyBoardEvent(data){
                //console.log('webKeyBoardEvent==>1', data)
                this.updateKeyBoard({...data.value})
            },
            // 更新组合键
            updateKeyBoard({keyCode, type}){
                //console.log('webKeyBoardEvent==>2', type)
                e = window.event || event
                let index = this.keyBoard.indexOf(`${keyCode}`)
                switch (type) {
                    case 'up':
                        if(index>-1) this.keyBoard.splice(index, 1)
                        break
                    case 'down':
                        if(index<=-1) this.keyBoard.push(`${keyCode}`)
                        break
                }
                let keyBoardState=this.$store.state.menusKeyBoard;
                //console.log("keyBoardState状态：",keyBoardState)
                // 如果
                if(this.keyBoard.includes('116')){
                    e.preventDefault(); // 阻止默认刷新
                    this.beforePreview()
                    this.keyBoard = []
                } else if((this.keyBoard.includes('83') && this.keyBoard.includes('17')) || (this.keyBoard.includes('83') && this.keyBoard.includes('91'))){//组合键保存：ctrl+s
                    e.preventDefault();
                    this.keyBoard = []
                    this.save()
                } else if(this.keyBoard.includes('67') && e.ctrlKey && keyBoardState){//复制操作
                    if(!this.$store.state.menusKeyBoard)return false;//当前非操作焦点则无效
                    e.preventDefault();
                    this.keyBoard = []
                    let item=this.$store.state.menusDataIds[this.$store.state.menusData.lessonSelected];
                    lessonOper.lessonOper(item,"copy");
                    this.$message.success('课件复制成功')
                } else if(this.keyBoard.includes('88') && e.ctrlKey && keyBoardState){//剪切操作
                    if(!this.$store.state.menusKeyBoard)return false;
                    e.preventDefault();
                    this.keyBoard = []
                    let item=this.$store.state.menusDataIds[this.$store.state.menusData.lessonSelected];
                    lessonOper.lessonOper(item,"move");
                    this.$message.success('课件剪切成功')
                } else if(this.keyBoard.includes('86') && e.ctrlKey && keyBoardState){//粘贴操作
                    if(!this.$store.state.menusKeyBoard)return false;
                    e.preventDefault();
                    this.keyBoard = []
                    this.$refs.menus.pasteLesson();
                } else if(this.keyBoard.includes('65') && e.ctrlKey && keyBoardState){//全选课件
                    if(!this.$store.state.menusKeyBoard)return false;
                    e.preventDefault();
                    this.keyBoard = []
                    let children=this.menusDataIds[this.$store.state.menusData.blocksSelected].children;
                    
                    if(children=="" || children==undefined){
                        this.$message.success('场景无课件，无法全选')
                    }else{
                        this.onOperation({key: 'mulSelect'});
                        this.$store.state.mulSelect = []
                        console.log("children",children);
                        children.map(v => {
                            if (v) {
                                this.$store.state.mulSelect.push(v.unique);
                            }
                        })
                        this.$message.success('已全选当前场景课件')
                    }
                }else if(this.keyBoard.includes('90') && e.ctrlKey && keyBoardState){//全选课件
                    if(!this.$store.state.menusKeyBoard)return false;
                    e.preventDefault();
                    this.keyBoard = []
                    this.$store.state.mulSelect = null
                }else if(this.keyBoard.includes('27') && keyBoardState){//取消选择
                    if(!this.$store.state.menusKeyBoard)return false;
                    e.preventDefault();
                    this.keyBoard = []
                    this.$store.state.mulSelect = null
                }  
            },
            webDelResource(data){
                // TODO 删除资源处理
                console.log('cocos侧通知web侧删除资源', data)
                switch (data.type) {
                    case 'audio':
                        data.url && AudioDestory({url: data.url})
                }
            },
            webEditResource(data){
                this.isWordAudio = false
                // 唤醒素材选择
                console.log('唤醒素材选择',data)
                this.curEditItem = data
                this.categoryId = 0;
                switch (data.value.type) {
                    case 'dialog':
                        this.voiceConfig = data.value
                        this.isVoiceConfig = true
                        break;
                    case 'editScenes':
                        this.isCocos = true
                        this.webEditScenes(data.value, data)
                        break
                    case 'image':
                        this.isCocos = true
                        this.webEditImage(data.value, data)
                        break
                    case 'video':
                        this.isCocos = true
                        this.webEditVideo(data.value, data)
                        break
                    default:
                        this.isCocos = true
                        this.isMore = true
                        this.categoryId = data.value.category_id
                        this.moreType = data.value.type
                        this.callBack = data.callback
                        this.isWordAudio = false

                        console.log("当前名称：",data.value.category_id);

                        // 文音组件
                        if(data.selfFlag && ['AudioWord', 'AudioSelect'].includes(data.selfFlag.type)){
                            this.isWordAudio = true
                            this.selfFlag =  data.selfFlag
                        }
                }
            },
            webGoTokejian(value){
                // Like-1
                console.log('web端跳转课件', value)
                let index = -1
                this.$store.state.menusData.blocksForm.map((v,i)=>{
                    if(v.name === value.split('-')[0]){
                        index = i
                        this.$store.state.menusData.blocksForm.blocksSelected = index
                    }
                })
                console.log('retro lessonSelected5')
                this.$store.state.menusData.lessonSelected = `${index}/${value.split('-')[1]}`

            },
            webGetConfig(value){
              console.log('优化速度==>webGetConfig')
              // 改变当前配置课件的配置信息
              if(this.$store.state.menusData.lessonSelected){
                  let node = this.menusDataIds[this.menusData.lessonSelected] // this.$utils.getObjByCurLesson({})
                  node = value
                  console.log('当前菜单配置==>', node)
              }
            },
            // 设置字体设置模块展示及位置
            // left,top需要再加上web侧的相对位置
            webEditFont({...params}){
                this.curEditItem = params
                console.log('ele==>',params)
                this.isOperationFont = params.value.isShow
                // debugger

                let calcLeft = 0
                let calcTop = 0
                let calcHeight = 0
                try {
                    if(params.value.position){
                        calcLeft = Number.isInteger(params.value.position.left)?this.position.left:parseFloat(params.value.position.left.slice(0,-2))
                        calcTop = Number.isInteger(params.value.position.top)?this.position.top:parseFloat(params.value.position.top.slice(0,-2))
                        calcHeight = Number.isInteger(params.value.position.height)?this.position.height:parseFloat(params.value.position.height.slice(0,-2))
                    }
                }catch (e) {
                    console.log('获取位置失败==>', e)
                }
                let ele = document.querySelector('.loyout-right')
                let newLeft = calcLeft + ele.offsetLeft - 102
                this.newLeft = newLeft
                let newTop = calcTop + ele.offsetTop - 120
                // 处理上边界问题 如果上边界小于100 则展示在编辑文本下方
                if(newTop < 100) {
                    newTop = calcTop + ele.offsetTop + calcHeight + 20
                }
                this.newTop = newTop

                this.oldOperationFont = params.value
            },
            // 富文本编辑
            webEditText({...params}){
                this.curEditItem = params
                console.log('当前富文本字体情况：',params)
                this.textVisible=true;
                this.textData=params;
            },
            // 通知cocos当前字体配置
            onOperationFont(config){
                this.$toCocosMessage({...this.curEditItem, type: 'EditFont', value: {...config}})
            },
            // 通知cocos当前文字转语音
            onVoiceConfig(config){
                this.$toCocosMessage({...this.curEditItem, type: 'EditResource', value: {...config}})
            },
            // 鼠标左击操作
            getMouseIsLeft(){
                //getMouseIsLeft(event){
                //console.log('鼠标左击==>', event)
                if(this.optIsShow){
                    this.optIsShow = false
                    this.optItem = null
                }
            },
            // 刷新ppt导入记录
            flashPPTList(type){
                this.$refs.content &&
                this.$refs.content.flashPPTList &&
                this.$refs.content.flashPPTList(type)
            },
            // 初始化窗台弹窗
            flushStatus(){
                this.$refs.content &&
                this.$refs.content.flushStatus &&
                this.$refs.content.flushStatus()
            },
            // 刷新内容区
            flashContent(state){
                if(state) {
                    this.isContents = false
                    let fn = setTimeout(()=>{
                        this.isContents = true
                        clearTimeout(fn)
                    })
                }
            },
            // 鼠标右击操作
            getMouseIsRight(event){
                console.log('鼠标右击==>', event)
                if(this.mulSelect) return false
                if( this.newMouseEnterItem ||
                    this.newMouseEnterNav ||
                    this.newMouseEnterNavItem ||
                    this.newMouseEnterLessonList
                ) {
                    this.x = event.x
                    this.y = event.y

                    this.optIsShow = true

                    this.$nextTick(()=>{
                        // 右击弹窗 最低触碰
                        let screeHeight = document.documentElement.clientHeight
                        let contentHeight = document.querySelector('.operation').clientHeight
                        let subValue = screeHeight - contentHeight
                        if(this.y>=subValue){
                            this.y = subValue
                        }
                    })
                    this.optDataTitle="菜单";
                    if(this.newMouseEnterItem) {
                        this.optItem = JSON.parse(JSON.stringify(this.newMouseEnterItem))
                        this.optData = [{key: 'delete',value: '删除'},{key: 'move',value: '剪切'},{key: 'copy',value: '复制'}]
                        this.optData.push({key: 'paste',value: '粘贴'})
                        this.optData.push({key: 'mulSelect',value: '多选'})
                        this.optDataTitle="课件";
                    }else if(this.newMouseEnterLessonList) {
                        this.optItem = {}
                        this.optData = [{key: 'add',value: '添加'}]
                        this.optData.push({key: 'paste',value: '粘贴'})
                        this.optDataTitle="课件";
                    }else if(this.newMouseEnterNavItem){
                        this.optItem = JSON.parse(JSON.stringify(this.newMouseEnterNavItem))
                        this.optData = []
                        // 当前菜单为第一 或 第二菜单时，可以添加子菜单 (最多为三级菜单)
                        let node = this.$utils.curSelectedNode({unique: this.newMouseEnterNavItem.unique})
                        console.log('如果当前菜单下有内容，不允许创建子菜单==>', node)
                        if(node &&
                            `${node.id}`.split('-').length<3 &&
                            (!node.children || (node.children && node.children.length === 0))) {
                            // 游戏练习只有一级目录
                            if (this.nav_manage_edit && !this.isPractice) this.optData.push({key: 'editNavLeaf', value: '添加子菜单'})
                        }
                        if(this.nav_manage_edit)this.optData.push({key: 'editNavItem',value: '编辑'})
                        if(this.nav_manage_edit)this.optData.push({key: 'deleteNavItem',value: '删除'})
                        this.optDataTitle="导航";
                    }else if(this.newMouseEnterNav){
                        if(this.isPractice && this.$store.state.menusData.blocksForm && this.$store.state.menusData.blocksForm.length>=9){
                            this.optIsShow = false
                            this.$message.error('游戏练习目录最多只能建9个')
                            return false
                        }
                        this.optItem = {}
                        this.optData = []
                        if(this.nav_manage_edit)this.optData.push({key: 'addNavItem',value: '添加'})
                        // 游戏练习无导航可切换
                        if (!this.isPractice) this.optData.push({key: 'replaceNav',value: '切换'})

                        let isOld = LocalStorage.getConfig()
                        if (isOld && !this.isPractice) this.optData.push({key: 'copyConfig',value: '粘贴'})
                        this.optDataTitle="导航";
                    }
                }
            },
            // 右击菜单回调
            onOperation(item, data){
                console.log('右击选中', item, data)
                this.isOptType = item.key
                switch (item.key) {
                    case 'add':
                        this.$refs.menus.addLesson();
                        break;
                    case 'delete':
                        this.$refs.menus.deleteLesson(data, this.$store.state.menusData.blocksSelected)
                        break;
                    case 'copy':
                        console.log("this.$refs.menus",this.$refs.menus);
                        data=this.$store.state.menusDataIds[data.unique];
                        this.$refs.menus.copyLesson(data, this.$store.state.menusData.blocksSelected)
                        break;
                    case 'paste':
                        console.log("this.$refs.menus",this.$refs.menus);
                        this.$refs.menus.pasteLesson()
                        break;
                    case 'move':
                        this.$refs.menus.moveLesson(data, this.$store.state.menusData.blocksSelected)
                        break;
                    case 'addNavItem':
                        console.log('添加导航元素')
                        this.isOptToBlock = true
                        this.optToBlockItem = {fn: item.fn, addPage: item.addPage}
                        break;
                    case 'editNavLeaf':
                        console.log('添加子导航元素')
                        this.isOptToBlock = true
                        this.optToBlockItem = this.optItem
                        break;
                    case 'editNavItem':
                        this.isOptToBlock = true
                        this.optToBlockItem = this.optItem
                        console.log('编辑导航元素')
                        break;
                    case 'deleteNavItem': {
                        const deleteNode = this.$utils.curSelectedNode({unique: this.optItem.unique})
                        this.setSendKeyBoardToCocos({key: 'isDeleteNav', value: false})
                        this.$confirm(`此操作将删除导航【${this.optItem.name}】及以下所有课件, 是否继续?`, '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            console.log('删除导航元素03', deleteNode, this.optItem.unique)
                            if((deleteNode.children && deleteNode.children.length>0) || (deleteNode.leaf && deleteNode.leaf.length>0)){
                                let operation=[];
                                deleteNode.children.map((v,index)=>{
                                    operation.push({node: 'children',toUnique: v.unique,operation: 'delete'});
                                    console.log(index);
                                })
                                //this.$message.error('当前导航内存在内容，不允许删除')
                                //return false
                            }
                            // 删除导航
                            this.$utils.curSelectedNode({unique: this.optItem.unique, type: 'delete'})

                            // TODO 删除导航
                            const operation = [{node: 'leaf', toUnique:this.optItem.unique, operation: 'delete'}]
                            $eventBus.$emit('__save__',true,null, operation)
                            console.log('操作==>删除导航', operation, this.optItem)

                            // 当删除的导航是默认的导航则，重新选中第一个导航的 所有第一个子导航
                            if(`${this.optItem.unique}` === `${this.$store.state.menusData.blocksSelected}`){
                                this.defaultSelectMenu(true)
                            }

                            // this.optToBlockItem = this.optItem
                            // let data = this.$store.state.menusData
                            // data.blocksForm.splice(this.optToBlockItem.index, 1)
                            // this.$store.dispatch('setMenusData', data)
                            // // TODO 更新导航接口
                            // this.updateNavData()

                        }).catch(() => {
                        }).finally(()=>{
                            this.setSendKeyBoardToCocos({key: 'isDeleteNav', value: true})
                        })
                        break;
                    }
                    case 'replaceNav':
                        this.isOptToBlock = true
                        this.optToBlockItem = {
                            scenes_stage_id:this.$store.state.menusData.scenes_stage_id,
                            scenes_state_shop:this.$store.state.menusData.scenes_stage_shop,
                        }
                        console.log('切换导航')
                        break;
                    case 'copyConfig':
                        this.copyConfig()
                        break;
                    case 'mulSelect':
                        this.$store.state.mulSelect = []
                        break;
                    default:
                }
                setTimeout(() => {
                    this.handleMouseEnterClose();
                }, 100);
            },
            copyConfig(){
                let data = LocalStorage.getConfig()
                console.log('配置表单存在复制1==>', data)
                console.log('配置表单存在复制2==>', typeof data)
                if(data && `${JSON.parse(data).schoolInfo.domain}` === this.$store.getters.getShoolConfig.domain) {
                    this.$confirm(`【${JSON.parse(data).title}】课件配置已经复制,是否粘贴到当前课件`, '课件粘贴确认', {
                        confirmButtonText: '粘贴',
                        cancelButtonText: '取消',
                    }).then(() => {
                        // 粘贴 合入当前课件的配置中
                        console.log('TODO 粘贴22==>', JSON.parse(data).config.h5_remote)
                        let menusData = this.$store.state.menusData
                        let curBlockForms = this.$store.state.menusData.blocksForm
                        let copyedBlockForms = JSON.parse(data).config.h5_remote.blocksForm || []
                        // 更新下unique
                        copyedBlockForms = this.$utils.addUniqueByArr({data: copyedBlockForms})
                        const templateData = this.$_.cloneDeepWith(copyedBlockForms)

                        // let blockForms = curBlockForms.concat(copyedBlockForms)
                        let blockForms = curBlockForms
                        Array.prototype.push.apply(blockForms, copyedBlockForms)
                        menusData.blocksForm = blockForms

                        const newData = this.$utils.one2TwoTree({data:  this.$_.cloneDeepWith(menusData)})
                        menusData = newData.menusData

                        // 获取实际映射的ids列表
                        const {menusIds} = this.$utils.one2TwoTree({data: {...menusData, blocksForm: this.$_.cloneDeepWith(templateData)}, ids: this.menusDataIds})
                        this.$store.state.menusDataIds = {...this.$store.state.menusDataIds, ...menusIds}

                        // TODO 粘贴课件
                        const operation = [
                            {data:templateData,operation: 'merge'}
                        ]
                        $eventBus.$emit('__save__',true,null, operation)
                        console.log('操作==>粘贴课件', operation)

                        // 如果菜单未选中，默认选中第一个场景第一个课件
                        if(!menusData.blocksSelected || !menusData.lessonSelected || menusData.lessonSelected === '0/0') {
                            menusData.blocksSelected = this.$utils.getFirstMenu({data: blockForms});
                            console.log('当前选中==>blocksSelected', menusData.blocksSelected, blockForms)
                            let node = this.$utils.curSelectedNode({data: blockForms, unique: menusData.blocksSelected})
                            if(node && node.children && node.children.length){
                                menusData.lessonSelected = node.children[0].unique
                            } else {
                                menusData.lessonSelected = ''
                            }
                        }

                        console.log('789==>', copyedBlockForms, blockForms)

                        let curH5Original = this.$store.state.urlMap
                        let copyH5Original = JSON.parse(data).config.h5_remote.urlMap || []
                        let h5_original = curH5Original.concat(copyH5Original)

                        this.$store.state.menusData.blocksForm = blockForms
                        this.$store.dispatch('setNewUrlMap', h5_original)
                        this.$message({
                            type: 'success',
                            message: '粘贴成功!'
                        });
                    }).catch((e) => {
                        console.log('取消粘贴==>', e)
                        this.$message({
                            type: 'info',
                            message: '已取消粘贴'
                        });
                    }).finally(()=>{
                        LocalStorage.removeConfig()
                    })
                }
            },
            // 获取当前选中的游戏类型
            getCurType(){
                let name = ''
                try {
                    const arr =  this.$store.state.menusData.lessonSelected.split('/')
                    name = this.$store.state.menusData.blocksForm[arr[0]].children[arr[1]].type
                }catch (e) {
                    console.log('获取当前选中游戏类型失败==>', e)
                }
                return name
            },
            // 预览之前通知cocos先保存当前配置
            beforePreview () {
                if(!this.isHasOneMenu){
                    this.$message.error(IsHasOneMenu)
                    return false
                }

                const time = this.isGameSaving() || 0
                const fn = setTimeout(()=>{
                    this.$toCocosMessage({type: 'SaveConfig', value: {flag: 'preview'}})
                    clearTimeout(fn)
                }, time + 200)
            },
            // 退出之前通知cocos先保存当前配置
            beforeQuit () {
                if(!this.isHasOneMenu){
                    window.location.href="about:blank"
                    window.close()
                    return false
                }
                //如果当前是游戏 预览之前向通知cocos侧保存当前配置
                // if (this.getCurType() === 'game') {
                    this.$toCocosMessage({type: 'SaveConfig', value: {flag: 'quit'}})
                // } else {
                //     this.preview()
                // }
            },
            // 刷新ppt
            flashPPT(){
              this.$refs.content &&
              this.$refs.content.flashPPTList &&
              this.$refs.content.flashPPTList()
            },
            // 预览
            preview(){
                if(!this.isPractice && !this.$route.query.id){
                    this.$message.error('请先保存')
                    return false
                }
                let obj = {scene:'preview',platform:'vue',...this.$route.query, isEdit: true}
                // this.$RouteUtil.preview(obj)
                let str = ''
                for(let item in obj){
                    str+= `&${item}=${obj[item]}`
                }
                console.log("obj",obj);
                window.open(`${Config.imeditPreview}?${str}`)
                // console.log('预览==>')
                // this.$message.success('预览')
                // Word2Voice({text:'预览'})
            },
            // 保存
            save(){
                if(!this.isHasOneMenu){
                    this.$message.error(IsHasOneMenu)
                    return false
                }
                // 1.判断当前是否有课件背景图
                // 2.如果无课件背景图，拿菜单内的第一背景图
                // 3.如果都没有背景图 则拿默认图

                let cover = this.lessonInfo.cover || (this.oldDetailData && this.oldDetailData.cover)
                console.log('保存1==>', cover)
                if(!cover){
                    cover = this.$utils.getFirstCover()
                    this.lessonInfo.cover = cover
                }
                console.log('保存2==>', cover)
                // this.$message.success('保存')
                // Word2Voice({text:'保存'})

                const time = this.isGameSaving() || 0
                const fn = setTimeout(()=>{
                    // 向cocos发起保存
                    this.$toCocosMessage({type: 'SaveConfig', value: {flag: 'save'}})
                    clearTimeout(fn)
                }, time + 200)
                // // 保存课件配置，服务器素材标记，前端配置
                // this.saveConfig()
            },
            atBeforeSend(){// 向cocos发起保存
                if(!this.isHasOneMenu){
                    this.$message.error(IsHasOneMenu)
                    return false
                }
                const time = this.isGameSaving() || 0
                const fn = setTimeout(()=>{
                    this.$toCocosMessage({type: 'SaveConfig', value: {flag: 'beforeSend'}})
                    clearTimeout(fn)
                }, time + 200)
            },
            // 发布之前
            async beforeSend(){
                if(!this.$store.getters.isPlat && !this.$store.state.permissions['class_mamage_edit']){
                    this.$message.error('当前没权限操作')
                    return false
                }
                if(this.isSending){
                    return false
                }
                if (this.isProgress) {
                    return false
                }
                if(!this.isPractice && !this.$route.query.id){
                    this.$message.error('请先保存')
                    return false
                }
                let warnConfig = LocalStorage.getWarn()
                if(warnConfig &&
                    (
                        `${JSON.parse(warnConfig).id}` === `${this.$route.query.id}`
                        ||
                        `${JSON.parse(warnConfig).practiceId}` === `${this.$route.query.practice_id}`
                    )
                    &&
                    `${JSON.parse(warnConfig).validate}` === 'true'
                ){
                    this.isSending = true
                    this.send()
                    return false
                }
                this.isBeforePackat = true
            },
            // 发布
            async send(){
                let res = null
                if(this.isPractice){
                    // TODO 游戏练习发布
                    res = await commonServer.default.packetExerciseGame({
                        id:this.$route.query.practice_id,
                        clientsId: this.$store.state.initConfig.school_id,
                        cocos_remote: this.cocosConfig()
                    })
                    console.log('练习发布==>', res)
                }else {
                    console.log('发布==>')
                    res = await resultServer.sendPacket({
                        id: this.$route.query.id,
                        clientsId: this.$store.state.initConfig.school_id,
                        cocos_remote: this.cocosConfig()
                    })
                }
                if(res && res.data && res.data.attr_id_last) {
                    this.getPackStatus({ attrId:res.data.attr_id_last })
                    this.progressFn = setInterval( () => {
                        this.getPackStatus({ attrId:res.data.attr_id_last })
                    }, 1000)
                    // this.init()
                }
            },
            async getPackStatus ({ attrId }) {
                this.isProgress = true
                let result = null
                if(this.isPractice){
                    result = await commonServer.default.packetExerciseGameStatus({
                        practiceId: this.$route.query.practice_id,
                        attrId
                    })
                } else {
                    result = await resultServer.getPacketResult({
                        resultId: this.$route.query.id,
                        attrId
                    })
                }
                if(result.data.progress >= 100) {
                    this.closeProgress()
                }
                this.progressValue = result.data.progress
                if (result.data.status === 'success') {
                    this.$refs.detail && this.$refs.detail.handleClose && this.$refs.detail.handleClose()
                    this.$message.success('发布成功')
                    this.closeProgress()
                } else if (result.data.status === 'failure'){
                    this.closeProgress()
                    this.$message.warning('打包失败')
                }
            },
            closeProgress(){
                this.isProgress = false
                this.isSending = false
                this.progressValue = 0
                clearInterval(this.progressFn)
            },
            // 更新名称和标题
            onUpdate(data){
                this.lessonInfo.name = data.name
                this.lessonInfo.title = data.title
                this.lessonInfo.cover = data.cover
            },
            // 保存配置
            async saveConfig(isCocos, callback, opts, isPublish, flag){
                // 判断当前是否有保存权限
                if(!this.$store.getters.isPlat && !this.$store.state.permissions['class_mamage_edit'] && this.$store.state.permissions.length){
                    this.$message.error('当前没权限操作')
                    return false
                }
                // 初始创建 防止连续保持多次
                // if(this.$utils.isFastExecute() && !this.$route.query.id){
                //     return false
                // }

                // TODO 保存当前正在编辑的配置
                // console.time('[耗时]获取当前选中课件时间')
                let operation = []
                if(opts){
                    operation = opts
                } else {
                    // const nodeUnique = this.$utils.getObjByCurLesson({
                    //     data: this.$_.cloneDeepWith(this.$store.state.menusData.blocksForm),
                    //     unique: this.$store.state.menusData.lessonSelected
                    // })
                    const nodeUnique = this.$store.state.menusDataIds[this.$store.state.menusData.lessonSelected]
                    //console.timeEnd('[耗时]获取当前选中课件时间')
                    const toUnique = nodeUnique && nodeUnique.unique
                    const operation = [{node: 'children', toUnique, data: nodeUnique, operation: 'edit'}]
                    console.log('操作==>保存课件', operation)
                }
                if(operation && operation[0] && operation[0].toUnique) {
                    this.observerPrettify(isCocos, callback, operation, isPublish, flag)
                    return false
                } else if(callback){
                    callback()
                    return false
                }
                // if(callback) {
                //     callback()
                //     return false
                // }
            },
            oldSave(isCocos, callback){
                this.observerPrettify(isCocos, callback, [])
                // let obj = this.getConfigData()
                // console.warn('获取配置==>', obj)
                // if (!obj.name || !obj.title) {
                //     return false
                // }
                // let res = null
                // if(this.isPractice){
                //     // 游戏练习如果practice_id存在时，走编辑接口 否则走新建接口
                //     if(this.isPracticeId){
                //         res = await commonServer.default.updateExerciseGame(obj)
                //     } else {
                //         res = await commonServer.default.addExerciseGame(obj)
                //     }
                // } else if(this.$route.query.id){
                //     let newObj = {id: this.$route.query.id, ...obj}
                //     if(this.isTemplate){
                //         res = await commonServer.default[this.updateResource](newObj)
                //     }else {
                //         res = await resultServer.updateResult(newObj)
                //     }
                // }else {
                //     if(this.isTemplate){
                //         res = await commonServer.default[this.addResource](obj)
                //     }else {
                //         res = await resultServer.addResult(obj)
                //     }
                // }
                // if(res && res.status_code === 200) {
                //     !isCocos && this.$message.success('保存成功', this.$route.query.id)
                //
                //     if(this.isPractice){
                //         if(!this.isPracticeId) {
                //             this.$RouteUtil.main({...this.$route.query, practice_id: res.data.id || 1})
                //         }
                //     }
                //     // 如果id不存在则 保存成功把id赋值在上面，下次保存就是编辑
                //     else if(!this.$route.query.id) {
                //         this.$RouteUtil.main({...this.$route.query, id: res.data.id})
                //     }
                //     if(this.$refs.top) {
                //         this.$refs.top.isEditName = false
                //         this.$refs.top.isEditTitle = false
                //     }
                //     // 保存成功执行回调
                //     callback && callback()
                // }else {
                //     !isCocos && this.$message.error('保存失败')
                // }
                // console.log('保存成功==>')
            },
            // 插入PPT
            insertPPT({resources_id, status, h5_remote, limit, index, cocos_dir, static_id}){
                console.log('插入ppt==>1', resources_id, status, h5_remote, limit)
                this.$refs.menus.realUpdateAndInsertPPT({resources_id, status, h5_remote, limit, index, cocos_dir, static_id})
            },
            async getUserInfoDetail(){
                try {
                    if(location.protocol.indexOf('https') === -1) {
                        const res = await LoginServer.getUserInfoDetail()
                        if (res && res.data) {
                            eval(res.data)
                        }
                    }
                } catch (e) {
                    console.log(e)
                }
            },
            getConfigData(){
                // 计算所有真实计费的素材有那些 更新【h5_original】
                // let calcArr = this.$utils.getAllMd5({data: this.$store.state.menusData.blocksForm})
                // calcArr = this.$_.uniq(calcArr)
                // console.log('获取去重计费==>', calcArr)
                // let h5_original = []
                // if(this.$store.state.urlMap && this.$store.state.urlMap.length>0){
                //     h5_original = this.$store.state.urlMap.filter(v=>calcArr.includes(v.url))
                // }
                // console.log('真实计费标记==>', h5_original)
                // debugger

                // TODO 设置默认图
                let obj = {
                    clientsId: this.$store.state.initConfig.school_id,
                    "category_id":this.$store.state.initConfig.category_id,
                    "name":this.lessonInfo.name || (this.oldDetailData && this.oldDetailData.name),
                    "title":this.lessonInfo.title || (this.oldDetailData && this.oldDetailData.title),
                    "type":this.lessonInfo.type || (this.oldDetailData && this.oldDetailData.type),
                    "cover":this.lessonInfo.cover || (this.oldDetailData && this.oldDetailData.cover) || this.$images.default,
                    // "attributes":{
                    //     h5_original,
                    //     "h5_remote": {...this.$store.state.menusData, urlMap: h5_original},
                    //     "cocos_original": this.$store.state.urlMap,
                    //     "cocos_remote": this.cocosConfig()
                    // },
                    op_status: this.op_status
                }
                // console.log(obj)
                // debugger

                // 模版创建
                if(this.isTemplate){
                    obj = {
                        clientsId: this.$store.state.initConfig.school_id,
                        sort:'template',
                        categoryId:this.$store.state.initConfig.category_id,
                        name:this.lessonInfo.name,
                        "title":this.lessonInfo.title || (this.oldDetailData && this.oldDetailData.title),
                        "type":this.lessonInfo.type || (this.oldDetailData && this.oldDetailData.type),
                        "cover":this.lessonInfo.cover || (this.oldDetailData && this.oldDetailData.cover) || 'https://ucenter.yunkedun.com',
                        // attributes:{
                        //     "cover":this.lessonInfo.cover || (this.oldDetailData && this.oldDetailData.cover) || 'https://ucenter.yunkedun.com',
                        //     "h5_original":this.$store.state.urlMap,
                        //     "h5_remote": {...this.$store.state.menusData, urlMap: h5_original},
                        //     "cocos_original": this.$store.state.urlMap,
                        //     "cocos_remote": this.cocosConfig()
                        // },
                        op_status: this.op_status
                    }
                }
                if(this.isPractice){
                    obj = {
                        clientsId: this.$store.state.initConfig.school_id,
                        categoryId:this.$route.query.category_id,
                        result_id: this.$route.query.id,
                        name: this.lessonInfo.practiceName || (this.oldDetailData && this.oldDetailData.practiceName),
                        // attributes:{
                        //     "h5_original":this.$store.state.urlMap,
                        //     "h5_remote": {...this.$store.state.menusData, urlMap: h5_original},
                        //     "cocos_original": this.$store.state.urlMap,
                        //     "cocos_remote": this.cocosConfig(),
                        //     "cocos_style": this.practiceScene
                        // },
                    }
                    if(this.isPracticeId){
                        obj.id = this.$route.query.practice_id
                    }
                }
                // if(this.$route.query.id){obj.course_auth_token = keyList[this.key] && keyList[this.key].course_auth_token}
                return obj
            },
            // 更新导航数据
            async updateNavData(){
                let stageShop = this.$store.state.menusData.scenes_state_shop
                // 1.获取导航详情
                const res = await commonServer.default[stageShop?'getResourceShopDetail':'getResourceDetail']({
                    id: this.$store.state.menusData.scenes_stage_id,
                    clientsId: this.$store.state.initConfig.school_id
                })
                console.log('main->nav->detail', res)
                // 2.更新导航
                let attributes = res.data.attributes
                attributes.options = this.$store.state.menusData.blocksForm.map(v=>v.name)
                commonServer.default[stageShop?'updateResourceShop':'updateResource']({
                    id: this.$store.state.menusData.scenes_stage_id,
                    clientsId: this.$store.state.initConfig.school_id,
                    sort:'scenes_stage',
                    categoryId: res.data.category_id,
                    name: res.data.name,
                    attributes
                }).then(res=>{
                    // this.$message.success('更新成功', res)
                    console.log('导航更新成功==>', res)
                }).catch(err=>{
                    this.$message.error('导航操作失败', err)
                })
            },
            /**
            * [beforeunloadHandler 浏览器关闭时进行用户提示]
            * @return {[type]} [description]
            */
            beforeunloadHandler(e) {
                console.log("已经进入离开请求");
                //e = e || window.event;
                //if (e) {e.returnValue = "您是否确认离开此页面-您输入的数据可能不会被保存";}
                return e;
            },
            async saveUpdate(reload){
                try {
                    localData.api_save_request(reload);
                } catch (e) {
                    console.log("本地缓存提交错误",e)
                }
            },
            listData(){
                let apiDataCache=localStorage.getItem("api_data_cache");
                let apiData=localStorage.getItem("api_data");
                this.isCacheSave=(isNull(apiDataCache) && isNull(apiData))?1:0;
                if(this.isCacheSave){
                    this.$store.state.notice={ico:"",state:false,info:""};
                }else{
                    this.$store.state.notice={ico:"el-icon-error",state:true,info:"您打开的编辑器中存在未提交数据，等待成功后操作"};
                    setTimeout(() => {
                        this.listData();
                    }, 300);
                }
            },
            handleMouseEnterClose(){
                this.$store.state.menusKeyBoard=false;
            }
        },
        destroyed() {
            clearInterval(this.heatFn)
            $eventBus.$off('__save__')
            $eventBus.$off('onCurForm')
            $eventBus.$off('changeMenuItem')
            window.removeEventListener("beforeunload", e => {
                this.beforeunloadHandler(e);
            });
        }
    }
</script>

<style>
.guideStep{
    position: relative;
    z-index: 1000002 !important;
}
.guideStep:before{
    content: '';
    position: absolute;
    left: 4px;
    top: 4px;
    width: calc(100% - 12px);
    height: calc(100% - 12px);
    border: 2px dotted white;
    z-index: 1000002;
    border-radius: 8px;
}
.notice{
    width:100%;
    height: 100vh;
    position: fixed;
    top: 0px;
    left:0px;
    z-index: 1100;
    background-color:rgba(0,0,0,0.5);
    text-align: center;
    display:flex;
}
.notice .notice_title{
    padding:0px 15px;
    width: auto;
    max-width: 520px;
    height: 40px;
    border-radius: 4px;
    line-height: 40px;
    margin: 30px auto;
    flex: auto;
    color: #F56C6C;
    font-size:16px;
    background: #FEF0F0;
}

.notice .notice_title i{
    margin-right:10px;
}
</style>

<style lang="scss" scoped>
#course{
    display: none;
}
.container{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    /*min-width: 1000px;*/

    .guide{
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 100001;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;

        .type-guide{
            position: absolute;
            top: 0px;
            right: 0px;
            margin-top: 55px;
            height: calc(100vh - 55px)
        }
        .content-guide{
            position: absolute;
            top: 55px;
            left: 230px;
            width: calc(100% - 302px);
            height: calc(100% - 55px);
        }
    }

    .content{
        display: flex;
        height: calc(100vh - 54px);
        flex-direction: row;
        justify-content: space-between;

        .loyout-right{
            display: flex;
            position: relative;
            flex: 1;
            z-index: 200;
        }
    }

    &.deep-black{
        .content{
            background-color: #2C2D33;
        }
    }
    .edit_test{
        padding: 15px;
        width:320px;
        height:auto;
        min-height: 50px;
        position: fixed;
        right:50px;
        bottom:10px;
        z-index: 20170427520;
        color:#fff;
        font-size:12px;
        background-color:rgba(0, 0, 0, 0.5);
        pointer-events: none;
        ul{
            margin:0px;
            padding:0px;
            width:100%;
            height:auto;
            float:left;
            li{
                margin:0px;
                padding:0px;
                list-style:none;
                width:100%;
                line-height:20px;
                float:left;
            }
        }
    }
}
</style>